/*
 * (c) Copyright 2024 Calabrio, Inc.
 * All Rights Reserved. www.calabrio.com LICENSED MATERIALS
 * Property of Calabrio, Inc., Minnesota, USA
 *
 * No part of this publication may be reproduced, stored or transmitted,
 * in any form or by any means (electronic, mechanical, photocopying,
 * recording or otherwise) without prior written permission from Calabrio, Inc.
 */


const WyAnalyticsUtils = {
    getCustomerBehaviourConversationsByChannelsData() {
      return {
          label: 'Conversations by Channels',
          tooltips: 'Total conversations had between a customer and a<br /> virtual or live agent and the channels they communicated on.<br />  (i.e. web, Whatsapp, etc)',
          data: [
            {
              key: 'conversations',
              suffixKey: 'Conversations',
              label: 'VA Conversations',
              value: '600K',
              displayValue: '600K',
              selected: false,
              changeOver30Days: 88.88,
              daysPreviousValue: '0',
              startPeriodValue: '0',
              daysOvertimeRange: 30,
              changeFromStart: -88.88,
              prefix:'',
              suffix:'',
              chartData: [],
              trendGraph: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:ct="http://gionkunz.github.com/chartist-js/ct" width="120" height="50" class="ct-chart-line" viewBox="0 4.042 120 45.333" preserveAspectRatio="none" style="width:120;height:50"><g class="ct-grids"></g><g><g class="ct-series ct-series-a"><path d="M0,16.667L0,16.667L3.243,16.667L6.486,16.667L9.73,8.875L12.973,13.708L16.216,10.542L19.459,16.667L22.703,16.667L25.946,16.667L29.189,16.667L32.432,16.667L35.676,16.667L38.919,6.125L42.162,11.375L45.405,16.625L48.649,11.708L51.892,11.292L55.135,16.667L58.378,16.667L61.622,16.667L64.865,16.667L68.108,4.125L71.351,12.375L74.595,12.708L77.838,16.667L81.081,16.667L84.324,16.667L87.568,16.667L90.811,16.667L94.054,16.667L97.297,4.042L100.541,11.208L103.784,13.708L107.027,13.375L110.27,16.667L113.514,16.667L116.757,16.667L120,16.667L120,16.667Z" class="ct-area"></path><path d="M0,16.667L3.243,16.667L6.486,16.667L9.73,8.875L12.973,13.708L16.216,10.542L19.459,16.667L22.703,16.667L25.946,16.667L29.189,16.667L32.432,16.667L35.676,16.667L38.919,6.125L42.162,11.375L45.405,16.625L48.649,11.708L51.892,11.292L55.135,16.667L58.378,16.667L61.622,16.667L64.865,16.667L68.108,4.125L71.351,12.375L74.595,12.708L77.838,16.667L81.081,16.667L84.324,16.667L87.568,16.667L90.811,16.667L94.054,16.667L97.297,4.042L100.541,11.208L103.784,13.708L107.027,13.375L110.27,16.667L113.514,16.667L116.757,16.667L120,16.667" class="ct-line"></path></g><g class="ct-series ct-series-b"><path d="M0,16.667L0,45.208L3.243,46.875L6.486,16.667L9.73,16.667L12.973,16.667L16.216,16.667L19.459,16.667L22.703,17.958L25.946,22.208L29.189,43.625L32.432,46.375L35.676,16.667L38.919,16.667L42.162,16.667L45.405,16.667L48.649,16.667L51.892,16.667L55.135,16.667L58.378,40.292L61.622,49.375L64.865,16.667L68.108,16.667L71.351,16.667L74.595,16.667L77.838,16.667L81.081,16.708L84.324,18.625L87.568,42.542L90.811,48.958L94.054,16.667L97.297,16.667L100.541,16.667L103.784,16.667L107.027,16.667L110.27,16.667L113.514,19.958L116.757,43.625L120,48.875L120,16.667Z" class="ct-area"></path><path d="M0,45.208L3.243,46.875L6.486,16.667L9.73,16.667L12.973,16.667L16.216,16.667L19.459,16.667L22.703,17.958L25.946,22.208L29.189,43.625L32.432,46.375L35.676,16.667L38.919,16.667L42.162,16.667L45.405,16.667L48.649,16.667L51.892,16.667L55.135,16.667L58.378,40.292L61.622,49.375L64.865,16.667L68.108,16.667L71.351,16.667L74.595,16.667L77.838,16.667L81.081,16.708L84.324,18.625L87.568,42.542L90.811,48.958L94.054,16.667L97.297,16.667L100.541,16.667L103.784,16.667L107.027,16.667L110.27,16.667L113.514,19.958L116.757,43.625L120,48.875" class="ct-line"></path></g><g class="ct-series ct-series-c"><path d="M0,16.667L0,23.455L3.243,23.477L6.486,23.487L9.73,23.498L12.973,23.52L16.216,23.541L19.459,23.552L22.703,23.563L25.946,23.584L29.189,23.606L32.432,23.627L35.676,23.638L38.919,23.648L42.162,23.67L45.405,23.691L48.649,23.713L51.892,23.734L55.135,23.745L58.378,23.756L61.622,23.777L64.865,23.788L68.108,23.799L71.351,23.82L74.595,23.842L77.838,23.853L81.081,23.863L84.324,23.885L87.568,23.906L90.811,23.928L94.054,23.939L97.297,23.949L100.541,23.971L103.784,23.992L107.027,24.014L110.27,24.025L113.514,24.035L116.757,24.057L120,24.078L120,16.667Z" class="ct-area"></path><path d="M0,23.455L3.243,23.477L6.486,23.487L9.73,23.498L12.973,23.52L16.216,23.541L19.459,23.552L22.703,23.563L25.946,23.584L29.189,23.606L32.432,23.627L35.676,23.638L38.919,23.648L42.162,23.67L45.405,23.691L48.649,23.713L51.892,23.734L55.135,23.745L58.378,23.756L61.622,23.777L64.865,23.788L68.108,23.799L71.351,23.82L74.595,23.842L77.838,23.853L81.081,23.863L84.324,23.885L87.568,23.906L90.811,23.928L94.054,23.939L97.297,23.949L100.541,23.971L103.784,23.992L107.027,24.014L110.27,24.025L113.514,24.035L116.757,24.057L120,24.078" class="ct-line"></path></g></g><g class="ct-labels"></g></svg>',
              pieChartData: {
                title: 'Conversations by channels',
                tooltips: 'Conversations had by virtual or live agents and the channels they communicated on.',
                labels: ['Web', 'Facebook messanger', 'Whatsapp', 'Twitter'],
                // tooltips: 'Conversations split between channels',
                values: [15, 20, 60, 15],
                percent: [15, 20, 60, 15],
                displayValue: '80%',
                legends: ['Web', 'Facebook messanger', 'Whatsapp', 'Twitter'],
              },
              columnChartData: {
                title: 'Conversations split between channels',
                legends: ['Web', 'Facebook messanger', 'Whatsapp', 'Twitter'],
                traceData: []
              }
            },
          ]
      }
    },
    
    getCustomerBehaviourConversationsByDevicesData() {
        return {
            label: 'Conversations by Devices',
            tooltips: 'Conversations by device type (i.e. mobile, desktop, etc) between a customer and virtual or live agent.',
            data: [
                {
                    key: 'conversations',
                    suffixKey: 'Conversations',
                    label: 'VA Conversations',
                    subLabel: 'Conversations by devices',
                    value: '600K',
                    selected: false,
                    changeOver30Days: 2.1,
                    changeFromStart: -2.1,
                    suffix:'',
                    chartData: [],
                    trendGraph: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:ct="http://gionkunz.github.com/chartist-js/ct" width="120" height="50" class="ct-chart-line" viewBox="0 4.042 120 45.333" preserveAspectRatio="none" style="width:120;height:50"><g class="ct-grids"></g><g><g class="ct-series ct-series-a"><path d="M0,16.667L0,16.667L3.243,16.667L6.486,16.667L9.73,8.875L12.973,13.708L16.216,10.542L19.459,16.667L22.703,16.667L25.946,16.667L29.189,16.667L32.432,16.667L35.676,16.667L38.919,6.125L42.162,11.375L45.405,16.625L48.649,11.708L51.892,11.292L55.135,16.667L58.378,16.667L61.622,16.667L64.865,16.667L68.108,4.125L71.351,12.375L74.595,12.708L77.838,16.667L81.081,16.667L84.324,16.667L87.568,16.667L90.811,16.667L94.054,16.667L97.297,4.042L100.541,11.208L103.784,13.708L107.027,13.375L110.27,16.667L113.514,16.667L116.757,16.667L120,16.667L120,16.667Z" class="ct-area"></path><path d="M0,16.667L3.243,16.667L6.486,16.667L9.73,8.875L12.973,13.708L16.216,10.542L19.459,16.667L22.703,16.667L25.946,16.667L29.189,16.667L32.432,16.667L35.676,16.667L38.919,6.125L42.162,11.375L45.405,16.625L48.649,11.708L51.892,11.292L55.135,16.667L58.378,16.667L61.622,16.667L64.865,16.667L68.108,4.125L71.351,12.375L74.595,12.708L77.838,16.667L81.081,16.667L84.324,16.667L87.568,16.667L90.811,16.667L94.054,16.667L97.297,4.042L100.541,11.208L103.784,13.708L107.027,13.375L110.27,16.667L113.514,16.667L116.757,16.667L120,16.667" class="ct-line"></path></g><g class="ct-series ct-series-b"><path d="M0,16.667L0,45.208L3.243,46.875L6.486,16.667L9.73,16.667L12.973,16.667L16.216,16.667L19.459,16.667L22.703,17.958L25.946,22.208L29.189,43.625L32.432,46.375L35.676,16.667L38.919,16.667L42.162,16.667L45.405,16.667L48.649,16.667L51.892,16.667L55.135,16.667L58.378,40.292L61.622,49.375L64.865,16.667L68.108,16.667L71.351,16.667L74.595,16.667L77.838,16.667L81.081,16.708L84.324,18.625L87.568,42.542L90.811,48.958L94.054,16.667L97.297,16.667L100.541,16.667L103.784,16.667L107.027,16.667L110.27,16.667L113.514,19.958L116.757,43.625L120,48.875L120,16.667Z" class="ct-area"></path><path d="M0,45.208L3.243,46.875L6.486,16.667L9.73,16.667L12.973,16.667L16.216,16.667L19.459,16.667L22.703,17.958L25.946,22.208L29.189,43.625L32.432,46.375L35.676,16.667L38.919,16.667L42.162,16.667L45.405,16.667L48.649,16.667L51.892,16.667L55.135,16.667L58.378,40.292L61.622,49.375L64.865,16.667L68.108,16.667L71.351,16.667L74.595,16.667L77.838,16.667L81.081,16.708L84.324,18.625L87.568,42.542L90.811,48.958L94.054,16.667L97.297,16.667L100.541,16.667L103.784,16.667L107.027,16.667L110.27,16.667L113.514,19.958L116.757,43.625L120,48.875" class="ct-line"></path></g><g class="ct-series ct-series-c"><path d="M0,16.667L0,23.455L3.243,23.477L6.486,23.487L9.73,23.498L12.973,23.52L16.216,23.541L19.459,23.552L22.703,23.563L25.946,23.584L29.189,23.606L32.432,23.627L35.676,23.638L38.919,23.648L42.162,23.67L45.405,23.691L48.649,23.713L51.892,23.734L55.135,23.745L58.378,23.756L61.622,23.777L64.865,23.788L68.108,23.799L71.351,23.82L74.595,23.842L77.838,23.853L81.081,23.863L84.324,23.885L87.568,23.906L90.811,23.928L94.054,23.939L97.297,23.949L100.541,23.971L103.784,23.992L107.027,24.014L110.27,24.025L113.514,24.035L116.757,24.057L120,24.078L120,16.667Z" class="ct-area"></path><path d="M0,23.455L3.243,23.477L6.486,23.487L9.73,23.498L12.973,23.52L16.216,23.541L19.459,23.552L22.703,23.563L25.946,23.584L29.189,23.606L32.432,23.627L35.676,23.638L38.919,23.648L42.162,23.67L45.405,23.691L48.649,23.713L51.892,23.734L55.135,23.745L58.378,23.756L61.622,23.777L64.865,23.788L68.108,23.799L71.351,23.82L74.595,23.842L77.838,23.853L81.081,23.863L84.324,23.885L87.568,23.906L90.811,23.928L94.054,23.939L97.297,23.949L100.541,23.971L103.784,23.992L107.027,24.014L110.27,24.025L113.514,24.035L116.757,24.057L120,24.078" class="ct-line"></path></g></g><g class="ct-labels"></g></svg>',
                    pieChartData: {
                    title: 'Conversations by devices',
                    tooltips: 'Conversations had by virtual or live agents and the devices they communicated on.',
                    labels: ['desktop', 'mobile'],
                    values: [15, 20, 75],
                    displayValue: '600k',
                    legends: ['Desktop', 'Mobile'],
                    },
                    columnChartData: {
                    // title: 'Conversations split between languages',
                    legends: ['Desktop', 'Mobile'],
                    traceData: [
                        {
                        x: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
                        y: [20, 14, 23, 12, 32, 42, 43, 22, 21, 39, 40, 30],
                        hoverinfo: 'none',
                        name: 'Spanish',
                        type: 'bar',
                        marker: {
                            color: '#8A8EF4',
                            line: {
                                color: 'white',
                            }
                        }
                        },
                        {
                        x: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
                        y: [120, 14, 23, 12, 132, 42, 43, 22, 21, 39, 140, 30],
                        hoverinfo: 'none',
                        name: 'French',
                        type: 'bar',
                        marker: {
                            color: '#4D50E8',
                            line: {
                            color: 'white',
                            }
                        }
                        },
                        {
                        x: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
                        y: [20, 14, 23, 12, 32, 42, 43, 22, 21, 39, 40, 30],
                        hoverinfo: 'none',
                        name: 'English',
                        type: 'bar',
                        marker: {
                            color: '#0C2837',
                            line: {
                            color: 'white',
                            }
                        }
                        }
                    ]
                    }
                }
            ]
        }
    },
    
    getCustomerBehaviourCustomerFeedbackData() {
        return {
            label: 'Customer Feedback',
            tooltips: 'Opinions (ratings or written feedback) about messages, <br />journeys, articles and the overall chat experience. ',
            data: [
            {
                key: 'feedbackRate',
                suffixKey: 'FeedbackRate',
                label: 'Feedback rate',
              //   subLabel: 'Feedback rate - positive, negative, and no feedback',
                value: '70%',
                selected: false,
                changeOver30Days: 2.1,
                changeFromStart: -2.1,
                suffix:'%',
                chartData: [],
                trendGraph: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:ct="http://gionkunz.github.com/chartist-js/ct" width="120" height="50" class="ct-chart-line" viewBox="0 4.042 120 45.333" preserveAspectRatio="none" style="width:120;height:50"><g class="ct-grids"></g><g><g class="ct-series ct-series-a"><path d="M0,16.667L0,16.667L3.243,16.667L6.486,16.667L9.73,8.875L12.973,13.708L16.216,10.542L19.459,16.667L22.703,16.667L25.946,16.667L29.189,16.667L32.432,16.667L35.676,16.667L38.919,6.125L42.162,11.375L45.405,16.625L48.649,11.708L51.892,11.292L55.135,16.667L58.378,16.667L61.622,16.667L64.865,16.667L68.108,4.125L71.351,12.375L74.595,12.708L77.838,16.667L81.081,16.667L84.324,16.667L87.568,16.667L90.811,16.667L94.054,16.667L97.297,4.042L100.541,11.208L103.784,13.708L107.027,13.375L110.27,16.667L113.514,16.667L116.757,16.667L120,16.667L120,16.667Z" class="ct-area"></path><path d="M0,16.667L3.243,16.667L6.486,16.667L9.73,8.875L12.973,13.708L16.216,10.542L19.459,16.667L22.703,16.667L25.946,16.667L29.189,16.667L32.432,16.667L35.676,16.667L38.919,6.125L42.162,11.375L45.405,16.625L48.649,11.708L51.892,11.292L55.135,16.667L58.378,16.667L61.622,16.667L64.865,16.667L68.108,4.125L71.351,12.375L74.595,12.708L77.838,16.667L81.081,16.667L84.324,16.667L87.568,16.667L90.811,16.667L94.054,16.667L97.297,4.042L100.541,11.208L103.784,13.708L107.027,13.375L110.27,16.667L113.514,16.667L116.757,16.667L120,16.667" class="ct-line"></path></g><g class="ct-series ct-series-b"><path d="M0,16.667L0,45.208L3.243,46.875L6.486,16.667L9.73,16.667L12.973,16.667L16.216,16.667L19.459,16.667L22.703,17.958L25.946,22.208L29.189,43.625L32.432,46.375L35.676,16.667L38.919,16.667L42.162,16.667L45.405,16.667L48.649,16.667L51.892,16.667L55.135,16.667L58.378,40.292L61.622,49.375L64.865,16.667L68.108,16.667L71.351,16.667L74.595,16.667L77.838,16.667L81.081,16.708L84.324,18.625L87.568,42.542L90.811,48.958L94.054,16.667L97.297,16.667L100.541,16.667L103.784,16.667L107.027,16.667L110.27,16.667L113.514,19.958L116.757,43.625L120,48.875L120,16.667Z" class="ct-area"></path><path d="M0,45.208L3.243,46.875L6.486,16.667L9.73,16.667L12.973,16.667L16.216,16.667L19.459,16.667L22.703,17.958L25.946,22.208L29.189,43.625L32.432,46.375L35.676,16.667L38.919,16.667L42.162,16.667L45.405,16.667L48.649,16.667L51.892,16.667L55.135,16.667L58.378,40.292L61.622,49.375L64.865,16.667L68.108,16.667L71.351,16.667L74.595,16.667L77.838,16.667L81.081,16.708L84.324,18.625L87.568,42.542L90.811,48.958L94.054,16.667L97.297,16.667L100.541,16.667L103.784,16.667L107.027,16.667L110.27,16.667L113.514,19.958L116.757,43.625L120,48.875" class="ct-line"></path></g><g class="ct-series ct-series-c"><path d="M0,16.667L0,23.455L3.243,23.477L6.486,23.487L9.73,23.498L12.973,23.52L16.216,23.541L19.459,23.552L22.703,23.563L25.946,23.584L29.189,23.606L32.432,23.627L35.676,23.638L38.919,23.648L42.162,23.67L45.405,23.691L48.649,23.713L51.892,23.734L55.135,23.745L58.378,23.756L61.622,23.777L64.865,23.788L68.108,23.799L71.351,23.82L74.595,23.842L77.838,23.853L81.081,23.863L84.324,23.885L87.568,23.906L90.811,23.928L94.054,23.939L97.297,23.949L100.541,23.971L103.784,23.992L107.027,24.014L110.27,24.025L113.514,24.035L116.757,24.057L120,24.078L120,16.667Z" class="ct-area"></path><path d="M0,23.455L3.243,23.477L6.486,23.487L9.73,23.498L12.973,23.52L16.216,23.541L19.459,23.552L22.703,23.563L25.946,23.584L29.189,23.606L32.432,23.627L35.676,23.638L38.919,23.648L42.162,23.67L45.405,23.691L48.649,23.713L51.892,23.734L55.135,23.745L58.378,23.756L61.622,23.777L64.865,23.788L68.108,23.799L71.351,23.82L74.595,23.842L77.838,23.853L81.081,23.863L84.324,23.885L87.568,23.906L90.811,23.928L94.054,23.939L97.297,23.949L100.541,23.971L103.784,23.992L107.027,24.014L110.27,24.025L113.514,24.035L116.757,24.057L120,24.078" class="ct-line"></path></g></g><g class="ct-labels"></g></svg>',
                lineChartData: {
                    // title: '',
                    title: 'Feedback rate',
                    tooltips: 'Percent of total conversations where the bot asked<br />for feedback and received any type (ratings or written) <br />of feedback from the customer. Includes feedback on <br />messages, journeys, or articles. ',
                    xAxisData: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
                    yAxisData: [0, 3, 10, 25, 35, 45, 55, 65, 75, 85, 95, 100],
                    // yAxisData: [null, null, null, null, null, null, null, null, null, null, null, null],
                    legends: ['feedback rate'],
                    prefix:'',
                    suffix: '%'
                }
                },
                {
                    key: 'containedFeedback',
                    suffixKey: 'ContainedFeedback',
                    label: 'Contained feedback',
                  //   subLabel: 'Feedback rate - positive, negative, and no feedback',
                    value: '83%',
                    valueSuffix: '%',
                    selected: false,
                    changeOver30Days: 2.1,
                    changeFromStart: -2.1,
                    prefix:'',
                    suffix: '%',
                    chartData: [],
                    trendGraph: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:ct="http://gionkunz.github.com/chartist-js/ct" width="120" height="50" class="ct-chart-line" viewBox="0 0 120 29.032" preserveAspectRatio="none" style="width:120;height:50"><g class="ct-grids"></g><g><g class="ct-series ct-series-a"><path d="M0,25L0,25L4.138,25L8.276,25L12.414,25L16.552,25L20.69,25L24.828,25L28.966,25L33.103,25L37.241,25L41.379,25L45.517,25L49.655,25L53.793,25L57.931,25L62.069,25L66.207,25L70.345,25L74.483,25L78.621,25L82.759,25L86.897,25L91.034,25L95.172,25L99.31,25L103.448,25L107.586,25L111.724,0L115.862,0L120,0L120,25Z" class="ct-area"></path><path d="M0,25L4.138,25L8.276,25L12.414,25L16.552,25L20.69,25L24.828,25L28.966,25L33.103,25L37.241,25L41.379,25L45.517,25L49.655,25L53.793,25L57.931,25L62.069,25L66.207,25L70.345,25L74.483,25L78.621,25L82.759,25L86.897,25L91.034,25L95.172,25L99.31,25L103.448,25L107.586,25L111.724,0L115.862,0L120,0" class="ct-line"></path></g><g class="ct-series ct-series-b"><path d="M0,25L0,25L4.138,25L8.276,25L12.414,25L16.552,25L20.69,25L24.828,25L28.966,25L33.103,25L37.241,25L41.379,25L45.517,25L49.655,25L53.793,25L57.931,25L62.069,25L66.207,25L70.345,25L74.483,25L78.621,25L82.759,25L86.897,25L91.034,25L95.172,25L99.31,25L103.448,25L107.586,25L111.724,25L115.862,25L120,25L120,25Z" class="ct-area"></path><path d="M0,25L4.138,25L8.276,25L12.414,25L16.552,25L20.69,25L24.828,25L28.966,25L33.103,25L37.241,25L41.379,25L45.517,25L49.655,25L53.793,25L57.931,25L62.069,25L66.207,25L70.345,25L74.483,25L78.621,25L82.759,25L86.897,25L91.034,25L95.172,25L99.31,25L103.448,25L107.586,25L111.724,25L115.862,25L120,25" class="ct-line"></path></g><g class="ct-series ct-series-c"><path d="M0,25L0,29.032L4.138,28.582L8.276,28.131L12.414,27.681L16.552,27.23L20.69,26.78L24.828,26.329L28.966,25.879L33.103,25.428L37.241,24.978L41.379,24.527L45.517,24.077L49.655,23.626L53.793,23.176L57.931,22.725L62.069,22.275L66.207,21.824L70.345,21.374L74.483,20.923L78.621,20.473L82.759,20.022L86.897,19.572L91.034,19.121L95.172,18.671L99.31,18.22L103.448,17.77L107.586,17.319L111.724,16.869L115.862,16.418L120,15.968L120,25Z" class="ct-area"></path><path d="M0,29.032L4.138,28.582L8.276,28.131L12.414,27.681L16.552,27.23L20.69,26.78L24.828,26.329L28.966,25.879L33.103,25.428L37.241,24.978L41.379,24.527L45.517,24.077L49.655,23.626L53.793,23.176L57.931,22.725L62.069,22.275L66.207,21.824L70.345,21.374L74.483,20.923L78.621,20.473L82.759,20.022L86.897,19.572L91.034,19.121L95.172,18.671L99.31,18.22L103.448,17.77L107.586,17.319L111.724,16.869L115.862,16.418L120,15.968" class="ct-line"></path></g></g><g class="ct-labels"></g></svg>',
                    pieChartData: {
                    // title: '',
                    title: 'Contained feedback - positive, negative, no feedback and mixed feedback',
                    tooltips: 'Percent of total contained conversations that received any<br />type (ratings or written) of feedback from the customer,<br />and the positive/negative percentage split.',
                    labels: ['positive feedback', 'negative feedback', 'no feedback'],
                    values: [20, 85, 15],
                    suffix: '%',
                    displayValue: '70%',
                    legends: ['Positive feedback', 'Negative feedback', 'No feedback'],
                    },
                    columnChartData: {
                    // title: 'English conversations contained vs handed off',
                    legends: ['Contained', 'Handed off'],
                    traceData: [
                        {
                        x: [],
                        y: [],
                        name: 'Positive feedback',
                        key: 'positiveFeedback',
                        type: 'bar',
                        hoverinfo: 'none',
                        hovertemplate: '',
                        marker: {
                            color: '#0C2837',
                            line: {
                                color: 'white'
                            }
                        }
                        },
                        {
                        x: [],
                        y: [],
                        name: 'Negative feedback',
                        key: 'negativeFeedback',
                        type: 'bar',
                        hoverinfo: 'none',
                        hovertemplate: '',
                        marker: {
                            color: '#4D50E8',
                            line: {
                            color: 'white'
                            }
                        }
                        },
                        {
                            x: [],
                            y: [],
                            name: 'no feedback',
                            key: 'noFeedback',
                            hoverinfo: 'none',
                            hovertemplate: '',
                            type: 'bar',
                            marker: {
                                color: '#8A8EF4',
                                line: {
                                    color: 'white'
                                }
                            }
                        },
                        {
                            x: [],
                            y: [],
                            name: 'Mixed feedback',
                            key: 'mixedFeedback',
                            hoverinfo: 'none',
                            hovertemplate: '',
                            type: 'bar',
                            marker: {
                                color: '#8A8EF4',
                                line: {
                                    color: 'white'
                                }
                            }
                        }
                    ]
                    }
                },
                {
                    key: 'handedOffFeedback',
                    suffixKey: 'HandedOffFeedback',
                    label: 'Handed off feedback',
                    subLabel: 'Handed off feedback - positive, negative, no feedback and mixed feedback ',
                    value: '53%',
                    valueSuffix: '%',
                    selected: false,
                    changeOver30Days: 2.1,
                    changeFromStart: -2.1,
                    suffix:'%',
                    chartData: [],
                    trendGraph: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:ct="http://gionkunz.github.com/chartist-js/ct" width="120" height="50" class="ct-chart-line" viewBox="0 4.042 120 45.333" preserveAspectRatio="none" style="width:120;height:50"><g class="ct-grids"></g><g><g class="ct-series ct-series-a"><path d="M0,16.667L0,16.667L3.243,16.667L6.486,16.667L9.73,8.875L12.973,13.708L16.216,10.542L19.459,16.667L22.703,16.667L25.946,16.667L29.189,16.667L32.432,16.667L35.676,16.667L38.919,6.125L42.162,11.375L45.405,16.625L48.649,11.708L51.892,11.292L55.135,16.667L58.378,16.667L61.622,16.667L64.865,16.667L68.108,4.125L71.351,12.375L74.595,12.708L77.838,16.667L81.081,16.667L84.324,16.667L87.568,16.667L90.811,16.667L94.054,16.667L97.297,4.042L100.541,11.208L103.784,13.708L107.027,13.375L110.27,16.667L113.514,16.667L116.757,16.667L120,16.667L120,16.667Z" class="ct-area"></path><path d="M0,16.667L3.243,16.667L6.486,16.667L9.73,8.875L12.973,13.708L16.216,10.542L19.459,16.667L22.703,16.667L25.946,16.667L29.189,16.667L32.432,16.667L35.676,16.667L38.919,6.125L42.162,11.375L45.405,16.625L48.649,11.708L51.892,11.292L55.135,16.667L58.378,16.667L61.622,16.667L64.865,16.667L68.108,4.125L71.351,12.375L74.595,12.708L77.838,16.667L81.081,16.667L84.324,16.667L87.568,16.667L90.811,16.667L94.054,16.667L97.297,4.042L100.541,11.208L103.784,13.708L107.027,13.375L110.27,16.667L113.514,16.667L116.757,16.667L120,16.667" class="ct-line"></path></g><g class="ct-series ct-series-b"><path d="M0,16.667L0,45.208L3.243,46.875L6.486,16.667L9.73,16.667L12.973,16.667L16.216,16.667L19.459,16.667L22.703,17.958L25.946,22.208L29.189,43.625L32.432,46.375L35.676,16.667L38.919,16.667L42.162,16.667L45.405,16.667L48.649,16.667L51.892,16.667L55.135,16.667L58.378,40.292L61.622,49.375L64.865,16.667L68.108,16.667L71.351,16.667L74.595,16.667L77.838,16.667L81.081,16.708L84.324,18.625L87.568,42.542L90.811,48.958L94.054,16.667L97.297,16.667L100.541,16.667L103.784,16.667L107.027,16.667L110.27,16.667L113.514,19.958L116.757,43.625L120,48.875L120,16.667Z" class="ct-area"></path><path d="M0,45.208L3.243,46.875L6.486,16.667L9.73,16.667L12.973,16.667L16.216,16.667L19.459,16.667L22.703,17.958L25.946,22.208L29.189,43.625L32.432,46.375L35.676,16.667L38.919,16.667L42.162,16.667L45.405,16.667L48.649,16.667L51.892,16.667L55.135,16.667L58.378,40.292L61.622,49.375L64.865,16.667L68.108,16.667L71.351,16.667L74.595,16.667L77.838,16.667L81.081,16.708L84.324,18.625L87.568,42.542L90.811,48.958L94.054,16.667L97.297,16.667L100.541,16.667L103.784,16.667L107.027,16.667L110.27,16.667L113.514,19.958L116.757,43.625L120,48.875" class="ct-line"></path></g><g class="ct-series ct-series-c"><path d="M0,16.667L0,23.455L3.243,23.477L6.486,23.487L9.73,23.498L12.973,23.52L16.216,23.541L19.459,23.552L22.703,23.563L25.946,23.584L29.189,23.606L32.432,23.627L35.676,23.638L38.919,23.648L42.162,23.67L45.405,23.691L48.649,23.713L51.892,23.734L55.135,23.745L58.378,23.756L61.622,23.777L64.865,23.788L68.108,23.799L71.351,23.82L74.595,23.842L77.838,23.853L81.081,23.863L84.324,23.885L87.568,23.906L90.811,23.928L94.054,23.939L97.297,23.949L100.541,23.971L103.784,23.992L107.027,24.014L110.27,24.025L113.514,24.035L116.757,24.057L120,24.078L120,16.667Z" class="ct-area"></path><path d="M0,23.455L3.243,23.477L6.486,23.487L9.73,23.498L12.973,23.52L16.216,23.541L19.459,23.552L22.703,23.563L25.946,23.584L29.189,23.606L32.432,23.627L35.676,23.638L38.919,23.648L42.162,23.67L45.405,23.691L48.649,23.713L51.892,23.734L55.135,23.745L58.378,23.756L61.622,23.777L64.865,23.788L68.108,23.799L71.351,23.82L74.595,23.842L77.838,23.853L81.081,23.863L84.324,23.885L87.568,23.906L90.811,23.928L94.054,23.939L97.297,23.949L100.541,23.971L103.784,23.992L107.027,24.014L110.27,24.025L113.514,24.035L116.757,24.057L120,24.078" class="ct-line"></path></g></g><g class="ct-labels"></g></svg>',
                    pieChartData: {
                    // title: 'French conversations - contained vs handed off',
                    title: 'Handed off feedback - positive, negative, no feedback and mixed feedback ',
                    tooltips: 'The percentage of people who left feedback for<br /> conversations where the customer was transferred to a live <br />chat, and the positive/negative percentage split.',
                    labels: ['positive feedback', 'negative feedback', 'no feedback'],
                    values: [20, 85, 15],
                    displayValue: '70%',
                    suffix: '%',
                    legends: ['Positive feedback', 'Negative feedback', 'No feedback'],
                    },
                    columnChartData: {
                    // title: 'French conversations contained vs handed off',
                    legends: ['Contained', 'Handed off'],
                    traceData: 
                    [
                      {
                          x: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
                          y: [20, 34, 23, 12, 32, 42, 43, 22, 21, 39, 40, 30],
                          name: 'Positive feedback',
                          key: 'positiveFeedback',
                          hoverinfo: 'none',
                          hovertemplate: '',
                          type: 'bar',
                          marker: {
                              color: '#0C2837',
                              line: {
                                  color: 'white'
                              }
                          }
                      },
                      {
                          x: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
                          y: [120, 14, 23, 12, 12, 12, 43, 22, 21, 39, 140, 30],
                          name: 'Negative feedback',
                          key: 'negativeFeedback',
                          hoverinfo: 'none',
                          hovertemplate: '',
                          type: 'bar',
                          marker: {
                              color: '#4D50E8',
                              line: {
                              color: 'white'
                              }
                          }
                      },
                      {
                          x: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
                          y: [20, 34, 23, 12, 32, 42, 43, 22, 21, 39, 40, 30],
                          name: 'no feedback',
                          key: 'noFeedback',
                          hoverinfo: 'none',
                          hovertemplate: '',
                          type: 'bar',
                          marker: {
                              color: '#8A8EF4',
                              line: {
                                  color: 'white'
                              }
                          }
                      },
                      {
                        x: [],
                        y: [],
                        name: 'Mixed feedback',
                        key: 'mixedFeedback',
                        hoverinfo: 'none',
                        hovertemplate: '',
                        type: 'bar',
                        marker: {
                            color: '#8A8EF4',
                            line: {
                                color: 'white'
                            }
                        }
                      }
                    ]
                    }
                },
            ]
        }
    },
    
    getCustomerBehaviourLiveAgentHandlingData() {
        return {
            label: 'Handling Times',
            tooltips: 'Summary of live agent handling times related to customer interactions',
          //   buckets: true,
            filterSettings:{
              buckets: [
                  {
                      title:'Agent handling time',
                      key: 'averageHandlingTime',
                      suffix: 'm',
                      numberRange: [
                          {
                          startNumber: 0,
                          endNumber: 1
                          },
                          {
                          startNumber: 1,
                          endNumber: 2
                          },
                          {
                          startNumber: 2,
                          endNumber: null
                          }
                      ],
                      maxNumRange: 4,
                  },
                  {
                      title:'VA handling time',
                      key: 'averageBotTime',
                      suffix: 'm',
                      numberRange: [
                          {
                          startNumber: 0,
                          endNumber: 1
                          },
                          {
                          startNumber: 1,
                          endNumber: 2
                          },
                          {
                          startNumber: 2,
                          endNumber: null
                          }
                      ],
                      maxNumRange: 4,
                  },
                  {
                      title:'Agent response time',
                      key: 'averageResponseTime',
                      suffix: 'm',
                      numberRange: [
                          {
                          startNumber: 0,
                          endNumber: 1
                          },
                          {
                          startNumber: 1,
                          endNumber: 2
                          },
                          {
                          startNumber: 2,
                          endNumber: null
                          }
                      ],
                      maxNumRange: 4,
                  },
                  {
                      title:'Agent wait time',
                      key: 'averageWaitTime',
                      suffix: 'm',
                      numberRange: [
                          {
                          startNumber: 0,
                          endNumber: 1
                          },
                          {
                          startNumber: 1,
                          endNumber: 2
                          },
                          {
                          startNumber: 2,
                          endNumber: null
                          }
                      ],
                      maxNumRange: 4,
                  }
              ]
            },
            numTabsPerPage: 3,
            data: [
                {
                    key: 'averageHandlingTime',
                    suffixKey: 'AverageHandlingTime',
                    label: 'Agent handling time',
                    subLabel: 'Average agent handling time -> 1m, 1 - 5m, 5 - 10m, 10+ m',
                    isTimeUnit: true,
                    value: '05s',
                    displayValue: '05s',
                    selected: false,
                    changeOver30Days: 2.1,
                    changeFromStart: -2.1,
                    suffix:'',
                    chartData: [],
                    multiChart: true,
                    trendGraph: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:ct="http://gionkunz.github.com/chartist-js/ct" width="120" height="50" class="ct-chart-line" viewBox="0 4.042 120 45.333" preserveAspectRatio="none" style="width:120;height:50"><g class="ct-grids"></g><g><g class="ct-series ct-series-a"><path d="M0,16.667L0,16.667L3.243,16.667L6.486,16.667L9.73,8.875L12.973,13.708L16.216,10.542L19.459,16.667L22.703,16.667L25.946,16.667L29.189,16.667L32.432,16.667L35.676,16.667L38.919,6.125L42.162,11.375L45.405,16.625L48.649,11.708L51.892,11.292L55.135,16.667L58.378,16.667L61.622,16.667L64.865,16.667L68.108,4.125L71.351,12.375L74.595,12.708L77.838,16.667L81.081,16.667L84.324,16.667L87.568,16.667L90.811,16.667L94.054,16.667L97.297,4.042L100.541,11.208L103.784,13.708L107.027,13.375L110.27,16.667L113.514,16.667L116.757,16.667L120,16.667L120,16.667Z" class="ct-area"></path><path d="M0,16.667L3.243,16.667L6.486,16.667L9.73,8.875L12.973,13.708L16.216,10.542L19.459,16.667L22.703,16.667L25.946,16.667L29.189,16.667L32.432,16.667L35.676,16.667L38.919,6.125L42.162,11.375L45.405,16.625L48.649,11.708L51.892,11.292L55.135,16.667L58.378,16.667L61.622,16.667L64.865,16.667L68.108,4.125L71.351,12.375L74.595,12.708L77.838,16.667L81.081,16.667L84.324,16.667L87.568,16.667L90.811,16.667L94.054,16.667L97.297,4.042L100.541,11.208L103.784,13.708L107.027,13.375L110.27,16.667L113.514,16.667L116.757,16.667L120,16.667" class="ct-line"></path></g><g class="ct-series ct-series-b"><path d="M0,16.667L0,45.208L3.243,46.875L6.486,16.667L9.73,16.667L12.973,16.667L16.216,16.667L19.459,16.667L22.703,17.958L25.946,22.208L29.189,43.625L32.432,46.375L35.676,16.667L38.919,16.667L42.162,16.667L45.405,16.667L48.649,16.667L51.892,16.667L55.135,16.667L58.378,40.292L61.622,49.375L64.865,16.667L68.108,16.667L71.351,16.667L74.595,16.667L77.838,16.667L81.081,16.708L84.324,18.625L87.568,42.542L90.811,48.958L94.054,16.667L97.297,16.667L100.541,16.667L103.784,16.667L107.027,16.667L110.27,16.667L113.514,19.958L116.757,43.625L120,48.875L120,16.667Z" class="ct-area"></path><path d="M0,45.208L3.243,46.875L6.486,16.667L9.73,16.667L12.973,16.667L16.216,16.667L19.459,16.667L22.703,17.958L25.946,22.208L29.189,43.625L32.432,46.375L35.676,16.667L38.919,16.667L42.162,16.667L45.405,16.667L48.649,16.667L51.892,16.667L55.135,16.667L58.378,40.292L61.622,49.375L64.865,16.667L68.108,16.667L71.351,16.667L74.595,16.667L77.838,16.667L81.081,16.708L84.324,18.625L87.568,42.542L90.811,48.958L94.054,16.667L97.297,16.667L100.541,16.667L103.784,16.667L107.027,16.667L110.27,16.667L113.514,19.958L116.757,43.625L120,48.875" class="ct-line"></path></g><g class="ct-series ct-series-c"><path d="M0,16.667L0,23.455L3.243,23.477L6.486,23.487L9.73,23.498L12.973,23.52L16.216,23.541L19.459,23.552L22.703,23.563L25.946,23.584L29.189,23.606L32.432,23.627L35.676,23.638L38.919,23.648L42.162,23.67L45.405,23.691L48.649,23.713L51.892,23.734L55.135,23.745L58.378,23.756L61.622,23.777L64.865,23.788L68.108,23.799L71.351,23.82L74.595,23.842L77.838,23.853L81.081,23.863L84.324,23.885L87.568,23.906L90.811,23.928L94.054,23.939L97.297,23.949L100.541,23.971L103.784,23.992L107.027,24.014L110.27,24.025L113.514,24.035L116.757,24.057L120,24.078L120,16.667Z" class="ct-area"></path><path d="M0,23.455L3.243,23.477L6.486,23.487L9.73,23.498L12.973,23.52L16.216,23.541L19.459,23.552L22.703,23.563L25.946,23.584L29.189,23.606L32.432,23.627L35.676,23.638L38.919,23.648L42.162,23.67L45.405,23.691L48.649,23.713L51.892,23.734L55.135,23.745L58.378,23.756L61.622,23.777L64.865,23.788L68.108,23.799L71.351,23.82L74.595,23.842L77.838,23.853L81.081,23.863L84.324,23.885L87.568,23.906L90.811,23.928L94.054,23.939L97.297,23.949L100.541,23.971L103.784,23.992L107.027,24.014L110.27,24.025L113.514,24.035L116.757,24.057L120,24.078" class="ct-line"></path></g></g><g class="ct-labels"></g></svg>',
                    lineChartData: {
                      title: 'agent handling time',
                      tooltips: 'The average time between the first and last<br /> messages exchanged in a conversation between customer and an agent.',
                      xAxisData: [],
                      yAxisData: [],
                      legends: ['agent handling time'],
                      prefix:'',
                      suffix: 'm'
                    },
                    pieChartData: {
                    // title: 'Average live agent handling time',
                    tooltips: 'The average time between the first and last messages <br/>exchanged in a conversation between customer and an agent.',
                    labels: ['<1m', '1 - 2 m', '2+ m'],
                    values: [15, 20, 75],
                    displayValue: '600,000',
                    legends: ['<1m', '1 - 2 m', '2+ m'],
                    },
                    columnChartData: {
                    title: 'conversation volumes',
                    legends: ['>1m', '1 - 5 m', '5 - 10 m', '10+ m'],
                    traceData: [
                        {
                        x: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
                        y: [20, 14, 23, 12, 32, 42, 43, 22, 21, 39, 40, 30],
                        name: 'Spanish',
                        type: 'bar',
                        hoverinfo: 'none',
                        hovertemplate: '',
                        marker: {
                            color: '#0C2837',
                            line: {
                                color: 'white'
                            }
                        }
                        },
                        {
                        x: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
                        y: [120, 14, 23, 12, 132, 42, 43, 22, 21, 39, 140, 30],
                        name: 'French',
                        type: 'bar',
                        hoverinfo: 'none',
                        hovertemplate: '',
                        marker: {
                            color: '#4D50E8',
                            line: {
                            color: 'white'
                            }
                        }
                        },
                        {
                        x: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
                        y: [20, 14, 23, 12, 32, 42, 43, 22, 21, 39, 40, 30],
                        name: 'English',
                        type: 'bar',
                        hoverinfo: 'none',
                        hovertemplate: '',
                        marker: {
                            color: '#8A8EF4',
                            line: {
                            color: 'white'
                            }
                        }
                        }
                    ]
                    }
                },
                
                {
                    key: 'averageBotTime',
                    suffixKey: 'AverageBotTime',
                    label: 'VA handling time',
                    subLabel: 'Average VA handling time -> 1m, 1 - 5m, 5 - 10m, 10+ m',
                    isTimeUnit: true,
                    value: '05s',
                    displayValue: '05s',
                    selected: false,
                    changeOver30Days: 2.1,
                    changeFromStart: -2.1,
                    suffix:'',
                    chartData: [],
                    multiChart: true,
                    trendGraph: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:ct="http://gionkunz.github.com/chartist-js/ct" width="120" height="50" class="ct-chart-line" viewBox="0 4.042 120 45.333" preserveAspectRatio="none" style="width:120;height:50"><g class="ct-grids"></g><g><g class="ct-series ct-series-a"><path d="M0,16.667L0,16.667L3.243,16.667L6.486,16.667L9.73,8.875L12.973,13.708L16.216,10.542L19.459,16.667L22.703,16.667L25.946,16.667L29.189,16.667L32.432,16.667L35.676,16.667L38.919,6.125L42.162,11.375L45.405,16.625L48.649,11.708L51.892,11.292L55.135,16.667L58.378,16.667L61.622,16.667L64.865,16.667L68.108,4.125L71.351,12.375L74.595,12.708L77.838,16.667L81.081,16.667L84.324,16.667L87.568,16.667L90.811,16.667L94.054,16.667L97.297,4.042L100.541,11.208L103.784,13.708L107.027,13.375L110.27,16.667L113.514,16.667L116.757,16.667L120,16.667L120,16.667Z" class="ct-area"></path><path d="M0,16.667L3.243,16.667L6.486,16.667L9.73,8.875L12.973,13.708L16.216,10.542L19.459,16.667L22.703,16.667L25.946,16.667L29.189,16.667L32.432,16.667L35.676,16.667L38.919,6.125L42.162,11.375L45.405,16.625L48.649,11.708L51.892,11.292L55.135,16.667L58.378,16.667L61.622,16.667L64.865,16.667L68.108,4.125L71.351,12.375L74.595,12.708L77.838,16.667L81.081,16.667L84.324,16.667L87.568,16.667L90.811,16.667L94.054,16.667L97.297,4.042L100.541,11.208L103.784,13.708L107.027,13.375L110.27,16.667L113.514,16.667L116.757,16.667L120,16.667" class="ct-line"></path></g><g class="ct-series ct-series-b"><path d="M0,16.667L0,45.208L3.243,46.875L6.486,16.667L9.73,16.667L12.973,16.667L16.216,16.667L19.459,16.667L22.703,17.958L25.946,22.208L29.189,43.625L32.432,46.375L35.676,16.667L38.919,16.667L42.162,16.667L45.405,16.667L48.649,16.667L51.892,16.667L55.135,16.667L58.378,40.292L61.622,49.375L64.865,16.667L68.108,16.667L71.351,16.667L74.595,16.667L77.838,16.667L81.081,16.708L84.324,18.625L87.568,42.542L90.811,48.958L94.054,16.667L97.297,16.667L100.541,16.667L103.784,16.667L107.027,16.667L110.27,16.667L113.514,19.958L116.757,43.625L120,48.875L120,16.667Z" class="ct-area"></path><path d="M0,45.208L3.243,46.875L6.486,16.667L9.73,16.667L12.973,16.667L16.216,16.667L19.459,16.667L22.703,17.958L25.946,22.208L29.189,43.625L32.432,46.375L35.676,16.667L38.919,16.667L42.162,16.667L45.405,16.667L48.649,16.667L51.892,16.667L55.135,16.667L58.378,40.292L61.622,49.375L64.865,16.667L68.108,16.667L71.351,16.667L74.595,16.667L77.838,16.667L81.081,16.708L84.324,18.625L87.568,42.542L90.811,48.958L94.054,16.667L97.297,16.667L100.541,16.667L103.784,16.667L107.027,16.667L110.27,16.667L113.514,19.958L116.757,43.625L120,48.875" class="ct-line"></path></g><g class="ct-series ct-series-c"><path d="M0,16.667L0,23.455L3.243,23.477L6.486,23.487L9.73,23.498L12.973,23.52L16.216,23.541L19.459,23.552L22.703,23.563L25.946,23.584L29.189,23.606L32.432,23.627L35.676,23.638L38.919,23.648L42.162,23.67L45.405,23.691L48.649,23.713L51.892,23.734L55.135,23.745L58.378,23.756L61.622,23.777L64.865,23.788L68.108,23.799L71.351,23.82L74.595,23.842L77.838,23.853L81.081,23.863L84.324,23.885L87.568,23.906L90.811,23.928L94.054,23.939L97.297,23.949L100.541,23.971L103.784,23.992L107.027,24.014L110.27,24.025L113.514,24.035L116.757,24.057L120,24.078L120,16.667Z" class="ct-area"></path><path d="M0,23.455L3.243,23.477L6.486,23.487L9.73,23.498L12.973,23.52L16.216,23.541L19.459,23.552L22.703,23.563L25.946,23.584L29.189,23.606L32.432,23.627L35.676,23.638L38.919,23.648L42.162,23.67L45.405,23.691L48.649,23.713L51.892,23.734L55.135,23.745L58.378,23.756L61.622,23.777L64.865,23.788L68.108,23.799L71.351,23.82L74.595,23.842L77.838,23.853L81.081,23.863L84.324,23.885L87.568,23.906L90.811,23.928L94.054,23.939L97.297,23.949L100.541,23.971L103.784,23.992L107.027,24.014L110.27,24.025L113.514,24.035L116.757,24.057L120,24.078" class="ct-line"></path></g></g><g class="ct-labels"></g></svg>',
                    lineChartData: {
                      title: 'VA handling time',
                      tooltips: '',
                      xAxisData: [],
                      yAxisData: [],
                      legends: ['VA handling time'],
                      prefix:'',
                      suffix: 'm'
                    },
                    pieChartData: {
                    // title: 'Average live agent handling time',
                    tooltips: '',
                    labels: ['<1m', '1 - 2 m', '2+ m'],
                    values: [15, 20, 75],
                    displayValue: '600,000',
                    legends: ['<1m', '1 - 2 m', '2+ m'],
                    },
                    columnChartData: {
                    title: 'conversation volumes',
                    legends: ['>1m', '1 - 5 m', '5 - 10 m', '10+ m'],
                    traceData: [
                        {
                        x: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
                        y: [20, 14, 23, 12, 32, 42, 43, 22, 21, 39, 40, 30],
                        name: 'Spanish',
                        type: 'bar',
                        hoverinfo: 'none',
                        hovertemplate: '',
                        marker: {
                            color: '#0C2837',
                            line: {
                                color: 'white'
                            }
                        }
                        },
                        {
                        x: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
                        y: [120, 14, 23, 12, 132, 42, 43, 22, 21, 39, 140, 30],
                        name: 'French',
                        type: 'bar',
                        hoverinfo: 'none',
                        hovertemplate: '',
                        marker: {
                            color: '#4D50E8',
                            line: {
                            color: 'white'
                            }
                        }
                        },
                        {
                        x: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
                        y: [20, 14, 23, 12, 32, 42, 43, 22, 21, 39, 40, 30],
                        name: 'English',
                        type: 'bar',
                        hoverinfo: 'none',
                        hovertemplate: '',
                        marker: {
                            color: '#8A8EF4',
                            line: {
                            color: 'white'
                            }
                        }
                        }
                    ]
                    }
                },
                {
                    key: 'averageResponseTime',
                    suffixKey: 'AverageResponseTime',
                    label: 'Agent response time',
                    subLabel: 'Average agent response time -> 1m, 1 - 5m, 5 - 10m, 10+ m',
                    isTimeUnit: true,
                    value: '5m:03s',
                    displayValue: '5m:03s',
                    selected: false,
                    changeOver30Days: 2.1,
                    changeFromStart: -2.1,
                    suffix:'',
                    chartData: [],
                    multiChart: true,
                    trendGraph: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:ct="http://gionkunz.github.com/chartist-js/ct" width="120" height="50" class="ct-chart-line" viewBox="0 0 120 29.032" preserveAspectRatio="none" style="width:120;height:50"><g class="ct-grids"></g><g><g class="ct-series ct-series-a"><path d="M0,25L0,25L4.138,25L8.276,25L12.414,25L16.552,25L20.69,25L24.828,25L28.966,25L33.103,25L37.241,25L41.379,25L45.517,25L49.655,25L53.793,25L57.931,25L62.069,25L66.207,25L70.345,25L74.483,25L78.621,25L82.759,25L86.897,25L91.034,25L95.172,25L99.31,25L103.448,25L107.586,25L111.724,0L115.862,0L120,0L120,25Z" class="ct-area"></path><path d="M0,25L4.138,25L8.276,25L12.414,25L16.552,25L20.69,25L24.828,25L28.966,25L33.103,25L37.241,25L41.379,25L45.517,25L49.655,25L53.793,25L57.931,25L62.069,25L66.207,25L70.345,25L74.483,25L78.621,25L82.759,25L86.897,25L91.034,25L95.172,25L99.31,25L103.448,25L107.586,25L111.724,0L115.862,0L120,0" class="ct-line"></path></g><g class="ct-series ct-series-b"><path d="M0,25L0,25L4.138,25L8.276,25L12.414,25L16.552,25L20.69,25L24.828,25L28.966,25L33.103,25L37.241,25L41.379,25L45.517,25L49.655,25L53.793,25L57.931,25L62.069,25L66.207,25L70.345,25L74.483,25L78.621,25L82.759,25L86.897,25L91.034,25L95.172,25L99.31,25L103.448,25L107.586,25L111.724,25L115.862,25L120,25L120,25Z" class="ct-area"></path><path d="M0,25L4.138,25L8.276,25L12.414,25L16.552,25L20.69,25L24.828,25L28.966,25L33.103,25L37.241,25L41.379,25L45.517,25L49.655,25L53.793,25L57.931,25L62.069,25L66.207,25L70.345,25L74.483,25L78.621,25L82.759,25L86.897,25L91.034,25L95.172,25L99.31,25L103.448,25L107.586,25L111.724,25L115.862,25L120,25" class="ct-line"></path></g><g class="ct-series ct-series-c"><path d="M0,25L0,29.032L4.138,28.582L8.276,28.131L12.414,27.681L16.552,27.23L20.69,26.78L24.828,26.329L28.966,25.879L33.103,25.428L37.241,24.978L41.379,24.527L45.517,24.077L49.655,23.626L53.793,23.176L57.931,22.725L62.069,22.275L66.207,21.824L70.345,21.374L74.483,20.923L78.621,20.473L82.759,20.022L86.897,19.572L91.034,19.121L95.172,18.671L99.31,18.22L103.448,17.77L107.586,17.319L111.724,16.869L115.862,16.418L120,15.968L120,25Z" class="ct-area"></path><path d="M0,29.032L4.138,28.582L8.276,28.131L12.414,27.681L16.552,27.23L20.69,26.78L24.828,26.329L28.966,25.879L33.103,25.428L37.241,24.978L41.379,24.527L45.517,24.077L49.655,23.626L53.793,23.176L57.931,22.725L62.069,22.275L66.207,21.824L70.345,21.374L74.483,20.923L78.621,20.473L82.759,20.022L86.897,19.572L91.034,19.121L95.172,18.671L99.31,18.22L103.448,17.77L107.586,17.319L111.724,16.869L115.862,16.418L120,15.968" class="ct-line"></path></g></g><g class="ct-labels"></g></svg>',
                    lineChartData: {
                      title: 'agent response time',
                      tooltips: 'The average time it takes an agent to<br /> respond to a customer message.',
                      xAxisData: [],
                      yAxisData: [],
                      legends: ['agent response time'],
                      prefix:'',
                      suffix: 'm'
                    },
                    pieChartData: {
                    // title: 'English conversations - contained vs handed off',
                    labels: ['>1m', '1 - 5 m', '5 - 10 m', '10+ m'],
                    tooltips: 'The average time it takes an agent to respond to a customer message.',
                    values: [15, 20, 75],
                    displayValue: '600,000',
                    legends: ['>1m', '1 - 5 m', '5 - 10 m', '10+ m'],
                    },
                    columnChartData: {
                    title: 'conversation volumes',
                    legends: ['>1m', '1 - 5 m', '5 - 10 m', '10+ m'],
                    traceData: [
                        {
                        x: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
                        y: [20, 14, 23, 12, 32, 42, 43, 22, 21, 39, 40, 30],
                        name: 'Spanish',
                        type: 'bar',
                        hoverinfo: 'none',
                        hovertemplate: '',
                        marker: {
                            color: '#0C2837',
                            line: {
                                color: 'white'
                            }
                        }
                        },
                        {
                        x: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
                        y: [120, 14, 23, 12, 132, 42, 43, 22, 21, 39, 140, 30],
                        name: 'French',
                        type: 'bar',
                        hoverinfo: 'none',
                        hovertemplate: '',
                        marker: {
                            color: '#4D50E8',
                            line: {
                            color: 'white'
                            }
                        }
                        },
                        {
                        x: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
                        y: [20, 14, 23, 12, 32, 42, 43, 22, 21, 39, 40, 30],
                        name: 'English',
                        type: 'bar',
                        hoverinfo: 'none',
                        hovertemplate: '',
                        marker: {
                            color: '#8A8EF4',
                            line: {
                            color: 'white'
                            }
                        }
                        }
                    ]
                    }
                },
                {
                    key: 'averageWaitTime',
                    suffixKey: 'AverageWaitTime',
                    label: 'Agent wait time',
                    subLabel: 'Average agent wait time -> 1m, 1 - 5m, 5 - 10m, 10+ m',
                    isTimeUnit: true,
                    value: '4m:13s',
                    displayValue: '4m:13s',
                    selected: false,
                    changeOver30Days: 2.1,
                    changeFromStart: -2.1,
                    suffix:'',
                    chartData: [],
                    multiChart: true,
                    trendGraph: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:ct="http://gionkunz.github.com/chartist-js/ct" width="120" height="50" class="ct-chart-line" viewBox="0 4.042 120 45.333" preserveAspectRatio="none" style="width:120;height:50"><g class="ct-grids"></g><g><g class="ct-series ct-series-a"><path d="M0,16.667L0,16.667L3.243,16.667L6.486,16.667L9.73,8.875L12.973,13.708L16.216,10.542L19.459,16.667L22.703,16.667L25.946,16.667L29.189,16.667L32.432,16.667L35.676,16.667L38.919,6.125L42.162,11.375L45.405,16.625L48.649,11.708L51.892,11.292L55.135,16.667L58.378,16.667L61.622,16.667L64.865,16.667L68.108,4.125L71.351,12.375L74.595,12.708L77.838,16.667L81.081,16.667L84.324,16.667L87.568,16.667L90.811,16.667L94.054,16.667L97.297,4.042L100.541,11.208L103.784,13.708L107.027,13.375L110.27,16.667L113.514,16.667L116.757,16.667L120,16.667L120,16.667Z" class="ct-area"></path><path d="M0,16.667L3.243,16.667L6.486,16.667L9.73,8.875L12.973,13.708L16.216,10.542L19.459,16.667L22.703,16.667L25.946,16.667L29.189,16.667L32.432,16.667L35.676,16.667L38.919,6.125L42.162,11.375L45.405,16.625L48.649,11.708L51.892,11.292L55.135,16.667L58.378,16.667L61.622,16.667L64.865,16.667L68.108,4.125L71.351,12.375L74.595,12.708L77.838,16.667L81.081,16.667L84.324,16.667L87.568,16.667L90.811,16.667L94.054,16.667L97.297,4.042L100.541,11.208L103.784,13.708L107.027,13.375L110.27,16.667L113.514,16.667L116.757,16.667L120,16.667" class="ct-line"></path></g><g class="ct-series ct-series-b"><path d="M0,16.667L0,45.208L3.243,46.875L6.486,16.667L9.73,16.667L12.973,16.667L16.216,16.667L19.459,16.667L22.703,17.958L25.946,22.208L29.189,43.625L32.432,46.375L35.676,16.667L38.919,16.667L42.162,16.667L45.405,16.667L48.649,16.667L51.892,16.667L55.135,16.667L58.378,40.292L61.622,49.375L64.865,16.667L68.108,16.667L71.351,16.667L74.595,16.667L77.838,16.667L81.081,16.708L84.324,18.625L87.568,42.542L90.811,48.958L94.054,16.667L97.297,16.667L100.541,16.667L103.784,16.667L107.027,16.667L110.27,16.667L113.514,19.958L116.757,43.625L120,48.875L120,16.667Z" class="ct-area"></path><path d="M0,45.208L3.243,46.875L6.486,16.667L9.73,16.667L12.973,16.667L16.216,16.667L19.459,16.667L22.703,17.958L25.946,22.208L29.189,43.625L32.432,46.375L35.676,16.667L38.919,16.667L42.162,16.667L45.405,16.667L48.649,16.667L51.892,16.667L55.135,16.667L58.378,40.292L61.622,49.375L64.865,16.667L68.108,16.667L71.351,16.667L74.595,16.667L77.838,16.667L81.081,16.708L84.324,18.625L87.568,42.542L90.811,48.958L94.054,16.667L97.297,16.667L100.541,16.667L103.784,16.667L107.027,16.667L110.27,16.667L113.514,19.958L116.757,43.625L120,48.875" class="ct-line"></path></g><g class="ct-series ct-series-c"><path d="M0,16.667L0,23.455L3.243,23.477L6.486,23.487L9.73,23.498L12.973,23.52L16.216,23.541L19.459,23.552L22.703,23.563L25.946,23.584L29.189,23.606L32.432,23.627L35.676,23.638L38.919,23.648L42.162,23.67L45.405,23.691L48.649,23.713L51.892,23.734L55.135,23.745L58.378,23.756L61.622,23.777L64.865,23.788L68.108,23.799L71.351,23.82L74.595,23.842L77.838,23.853L81.081,23.863L84.324,23.885L87.568,23.906L90.811,23.928L94.054,23.939L97.297,23.949L100.541,23.971L103.784,23.992L107.027,24.014L110.27,24.025L113.514,24.035L116.757,24.057L120,24.078L120,16.667Z" class="ct-area"></path><path d="M0,23.455L3.243,23.477L6.486,23.487L9.73,23.498L12.973,23.52L16.216,23.541L19.459,23.552L22.703,23.563L25.946,23.584L29.189,23.606L32.432,23.627L35.676,23.638L38.919,23.648L42.162,23.67L45.405,23.691L48.649,23.713L51.892,23.734L55.135,23.745L58.378,23.756L61.622,23.777L64.865,23.788L68.108,23.799L71.351,23.82L74.595,23.842L77.838,23.853L81.081,23.863L84.324,23.885L87.568,23.906L90.811,23.928L94.054,23.939L97.297,23.949L100.541,23.971L103.784,23.992L107.027,24.014L110.27,24.025L113.514,24.035L116.757,24.057L120,24.078" class="ct-line"></path></g></g><g class="ct-labels"></g></svg>',
                    lineChartData: {
                      title: 'agent wait time',
                      tooltips: 'The average time a customer had to wait<br /> for a live agent. ',
                      xAxisData: [],
                      yAxisData: [],
                      legends: ['agent wait time'],
                      prefix:'',
                      suffix: 'm'
                    },
                    pieChartData: {
                    // title: 'French conversations - contained vs handed off',
                    tooltips: 'The average time a customer had to wait for a live agent.',
                    labels: ['>1m', '1 - 5 m', '5 - 10 m', '10+ m'],
                    values: [15, 20, 75],
                    displayValue: '600,000',
                    legends: ['>1m', '1 - 5 m', '5 - 10 m', '10+ m'],
                    },
                    columnChartData: {
                    title: 'conversation volumes',
                    legends: ['>1m', '1 - 5 m', '5 - 10 m', '10+ m'],
                    traceData: [
                        {
                        x: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
                        y: [20, 14, 23, 12, 32, 42, 43, 22, 21, 39, 40, 30],
                        name: 'Spanish',
                        type: 'bar',
                        hoverinfo: 'none',
                        hovertemplate: '',
                        marker: {
                            color: '#0C2837',
                            line: {
                                color: 'white'
                            }
                        }
                        },
                        {
                        x: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
                        y: [120, 14, 23, 12, 132, 42, 43, 22, 21, 39, 140, 30],
                        name: 'French',
                        type: 'bar',
                        marker: {
                            color: '#4D50E8',
                            line: {
                            color: 'white'
                            }
                        }
                        },
                        {
                        x: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
                        y: [20, 14, 23, 12, 32, 42, 43, 22, 21, 39, 40, 30],
                        name: 'English',
                        type: 'bar',
                        hoverinfo: 'none',
                        hovertemplate: '',
                        marker: {
                            color: '#8A8EF4',
                            line: {
                            color: 'white'
                            }
                        }
                        }
                    ]
                    }
                
                }
            ]
        }
    },
    
    getCustomerBehaviourNewAndReturningCustomersData() {
        return {
            label: 'New and Returning Customer Conversations',
            tooltips: 'Number of times customers interacted with virtual or<br /> live agents in the selected timeframe',
            data: [
                {
                    key: 'conversations',
                    suffixKey: 'Conversations',
                    label: 'VA Conversations',
                    subLabel: 'Returning customer conversations - positive, negative, no feedback and mixed feedback',
                    value: '40K',
                    selected: false,
                    changeOver30Days: 2.1,
                    changeFromStart: -2.1,
                    suffix:'',
                    chartData: [],
                    trendGraph: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:ct="http://gionkunz.github.com/chartist-js/ct" width="120" height="50" class="ct-chart-line" viewBox="0 4.042 120 45.333" preserveAspectRatio="none" style="width:120;height:50"><g class="ct-grids"></g><g><g class="ct-series ct-series-a"><path d="M0,16.667L0,16.667L3.243,16.667L6.486,16.667L9.73,8.875L12.973,13.708L16.216,10.542L19.459,16.667L22.703,16.667L25.946,16.667L29.189,16.667L32.432,16.667L35.676,16.667L38.919,6.125L42.162,11.375L45.405,16.625L48.649,11.708L51.892,11.292L55.135,16.667L58.378,16.667L61.622,16.667L64.865,16.667L68.108,4.125L71.351,12.375L74.595,12.708L77.838,16.667L81.081,16.667L84.324,16.667L87.568,16.667L90.811,16.667L94.054,16.667L97.297,4.042L100.541,11.208L103.784,13.708L107.027,13.375L110.27,16.667L113.514,16.667L116.757,16.667L120,16.667L120,16.667Z" class="ct-area"></path><path d="M0,16.667L3.243,16.667L6.486,16.667L9.73,8.875L12.973,13.708L16.216,10.542L19.459,16.667L22.703,16.667L25.946,16.667L29.189,16.667L32.432,16.667L35.676,16.667L38.919,6.125L42.162,11.375L45.405,16.625L48.649,11.708L51.892,11.292L55.135,16.667L58.378,16.667L61.622,16.667L64.865,16.667L68.108,4.125L71.351,12.375L74.595,12.708L77.838,16.667L81.081,16.667L84.324,16.667L87.568,16.667L90.811,16.667L94.054,16.667L97.297,4.042L100.541,11.208L103.784,13.708L107.027,13.375L110.27,16.667L113.514,16.667L116.757,16.667L120,16.667" class="ct-line"></path></g><g class="ct-series ct-series-b"><path d="M0,16.667L0,45.208L3.243,46.875L6.486,16.667L9.73,16.667L12.973,16.667L16.216,16.667L19.459,16.667L22.703,17.958L25.946,22.208L29.189,43.625L32.432,46.375L35.676,16.667L38.919,16.667L42.162,16.667L45.405,16.667L48.649,16.667L51.892,16.667L55.135,16.667L58.378,40.292L61.622,49.375L64.865,16.667L68.108,16.667L71.351,16.667L74.595,16.667L77.838,16.667L81.081,16.708L84.324,18.625L87.568,42.542L90.811,48.958L94.054,16.667L97.297,16.667L100.541,16.667L103.784,16.667L107.027,16.667L110.27,16.667L113.514,19.958L116.757,43.625L120,48.875L120,16.667Z" class="ct-area"></path><path d="M0,45.208L3.243,46.875L6.486,16.667L9.73,16.667L12.973,16.667L16.216,16.667L19.459,16.667L22.703,17.958L25.946,22.208L29.189,43.625L32.432,46.375L35.676,16.667L38.919,16.667L42.162,16.667L45.405,16.667L48.649,16.667L51.892,16.667L55.135,16.667L58.378,40.292L61.622,49.375L64.865,16.667L68.108,16.667L71.351,16.667L74.595,16.667L77.838,16.667L81.081,16.708L84.324,18.625L87.568,42.542L90.811,48.958L94.054,16.667L97.297,16.667L100.541,16.667L103.784,16.667L107.027,16.667L110.27,16.667L113.514,19.958L116.757,43.625L120,48.875" class="ct-line"></path></g><g class="ct-series ct-series-c"><path d="M0,16.667L0,23.455L3.243,23.477L6.486,23.487L9.73,23.498L12.973,23.52L16.216,23.541L19.459,23.552L22.703,23.563L25.946,23.584L29.189,23.606L32.432,23.627L35.676,23.638L38.919,23.648L42.162,23.67L45.405,23.691L48.649,23.713L51.892,23.734L55.135,23.745L58.378,23.756L61.622,23.777L64.865,23.788L68.108,23.799L71.351,23.82L74.595,23.842L77.838,23.853L81.081,23.863L84.324,23.885L87.568,23.906L90.811,23.928L94.054,23.939L97.297,23.949L100.541,23.971L103.784,23.992L107.027,24.014L110.27,24.025L113.514,24.035L116.757,24.057L120,24.078L120,16.667Z" class="ct-area"></path><path d="M0,23.455L3.243,23.477L6.486,23.487L9.73,23.498L12.973,23.52L16.216,23.541L19.459,23.552L22.703,23.563L25.946,23.584L29.189,23.606L32.432,23.627L35.676,23.638L38.919,23.648L42.162,23.67L45.405,23.691L48.649,23.713L51.892,23.734L55.135,23.745L58.378,23.756L61.622,23.777L64.865,23.788L68.108,23.799L71.351,23.82L74.595,23.842L77.838,23.853L81.081,23.863L84.324,23.885L87.568,23.906L90.811,23.928L94.054,23.939L97.297,23.949L100.541,23.971L103.784,23.992L107.027,24.014L110.27,24.025L113.514,24.035L116.757,24.057L120,24.078" class="ct-line"></path></g></g><g class="ct-labels"></g></svg>',
                    pieChartData: {
                    tooltips: 'Total conversations had between a customer and virtual or live <br/> agent, split between new and returning customer conversations',
                    title: 'Conversations - new and returning customer conversations',
                    labels: ['New customers', 'Returning customers'],
                    values: [20, 85],
                    displayValue: '40K',
                    legends: ['New customers', 'Returning customers'],
                    },
                    columnChartData: {
                    // title: 'Conversations split between languages',
                    legends: ['New customers', 'Returning customers'],
                    traceData: [
                        {
                        x: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
                        y: [20, 14, 23, 12, 32, 42, 43, 22, 21, 39, 40, 30],
                        name: 'new customers',
                        key: 'newCustomers',
                        type: 'bar',
                        hoverinfo: 'none',
                        hovertemplate: '',
                        marker: {
                            color: '#8A8EF4',
                            line: {
                                color: 'white'
                            }
                        }
                        },
                        {
                        x: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
                        y: [120, 14, 23, 12, 132, 42, 43, 22, 21, 39, 140, 30],
                        name: 'returning customers',
                        key: 'returningCustomers',
                        type: 'bar',
                        hoverinfo: 'none',
                        hovertemplate: '',
                        marker: {
                            color: '#4D50E8',
                            line: {
                            color: 'white'
                            }
                        }}
                    ]
                    }
                },
                {
                    key: 'newCustomerConversations',
                    suffixKey: 'NewCustomerConversations',
                    label: 'New customers',
                    subLabel: 'New customers - positive, negative, no feedback and mixed feedback',
                    value: '3K',
                    selected: false,
                    changeOver30Days: 2.1,
                    changeFromStart: -2.1,
                    suffix:'',
                    chartData: [],
                    trendGraph: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:ct="http://gionkunz.github.com/chartist-js/ct" width="120" height="50" class="ct-chart-line" viewBox="0 0 120 29.032" preserveAspectRatio="none" style="width:120;height:50"><g class="ct-grids"></g><g><g class="ct-series ct-series-a"><path d="M0,25L0,25L4.138,25L8.276,25L12.414,25L16.552,25L20.69,25L24.828,25L28.966,25L33.103,25L37.241,25L41.379,25L45.517,25L49.655,25L53.793,25L57.931,25L62.069,25L66.207,25L70.345,25L74.483,25L78.621,25L82.759,25L86.897,25L91.034,25L95.172,25L99.31,25L103.448,25L107.586,25L111.724,0L115.862,0L120,0L120,25Z" class="ct-area"></path><path d="M0,25L4.138,25L8.276,25L12.414,25L16.552,25L20.69,25L24.828,25L28.966,25L33.103,25L37.241,25L41.379,25L45.517,25L49.655,25L53.793,25L57.931,25L62.069,25L66.207,25L70.345,25L74.483,25L78.621,25L82.759,25L86.897,25L91.034,25L95.172,25L99.31,25L103.448,25L107.586,25L111.724,0L115.862,0L120,0" class="ct-line"></path></g><g class="ct-series ct-series-b"><path d="M0,25L0,25L4.138,25L8.276,25L12.414,25L16.552,25L20.69,25L24.828,25L28.966,25L33.103,25L37.241,25L41.379,25L45.517,25L49.655,25L53.793,25L57.931,25L62.069,25L66.207,25L70.345,25L74.483,25L78.621,25L82.759,25L86.897,25L91.034,25L95.172,25L99.31,25L103.448,25L107.586,25L111.724,25L115.862,25L120,25L120,25Z" class="ct-area"></path><path d="M0,25L4.138,25L8.276,25L12.414,25L16.552,25L20.69,25L24.828,25L28.966,25L33.103,25L37.241,25L41.379,25L45.517,25L49.655,25L53.793,25L57.931,25L62.069,25L66.207,25L70.345,25L74.483,25L78.621,25L82.759,25L86.897,25L91.034,25L95.172,25L99.31,25L103.448,25L107.586,25L111.724,25L115.862,25L120,25" class="ct-line"></path></g><g class="ct-series ct-series-c"><path d="M0,25L0,29.032L4.138,28.582L8.276,28.131L12.414,27.681L16.552,27.23L20.69,26.78L24.828,26.329L28.966,25.879L33.103,25.428L37.241,24.978L41.379,24.527L45.517,24.077L49.655,23.626L53.793,23.176L57.931,22.725L62.069,22.275L66.207,21.824L70.345,21.374L74.483,20.923L78.621,20.473L82.759,20.022L86.897,19.572L91.034,19.121L95.172,18.671L99.31,18.22L103.448,17.77L107.586,17.319L111.724,16.869L115.862,16.418L120,15.968L120,25Z" class="ct-area"></path><path d="M0,29.032L4.138,28.582L8.276,28.131L12.414,27.681L16.552,27.23L20.69,26.78L24.828,26.329L28.966,25.879L33.103,25.428L37.241,24.978L41.379,24.527L45.517,24.077L49.655,23.626L53.793,23.176L57.931,22.725L62.069,22.275L66.207,21.824L70.345,21.374L74.483,20.923L78.621,20.473L82.759,20.022L86.897,19.572L91.034,19.121L95.172,18.671L99.31,18.22L103.448,17.77L107.586,17.319L111.724,16.869L115.862,16.418L120,15.968" class="ct-line"></path></g></g><g class="ct-labels"></g></svg>',
                    pieChartData: {
                        title: 'New customer conversations - positive, negative, no feedback and mixed feedback',
                        tooltips:'Conversations that are happening for the first time ever<br/> across all dates for that customer ID.',
                        labels: ['positive feedback', 'negative feedback', 'no feedback'],
                        values: [15, 20, 75],
                        displayValue: '600,000',
                        legends: ['Positive feedback', 'Negative feedback', 'No feedback']
                        },
                        columnChartData: {
                        // title: 'Conversations split between languages',
                        legends: ['Positive feedback', 'Negative feedback', 'No feedback'],
                        traceData: [
                            {
                                x: [],
                                y: [],
                                name: 'Positive feedback',
                                key: 'positiveFeedback',
                                type: 'bar',
                                hoverinfo: 'none',
                                hovertemplate: '',
                                marker: {
                                    color: '#0C2837',
                                    line: {
                                        color: 'white'
                                    }
                                }
                                },
                                {
                                x: [],
                                y: [],
                                name: 'Negative feedback',
                                key: 'negativeFeedback',
                                type: 'bar',
                                hoverinfo: 'none',
                                hovertemplate: '',
                                marker: {
                                    color: '#4D50E8',
                                    line: {
                                    color: 'white'
                                    }
                                }
                                },
                                {
                                    x: [],
                                    y: [],
                                    name: 'no feedback',
                                    key: 'noFeedback',
                                    hoverinfo: 'none',
                                    hovertemplate: '',
                                    type: 'bar',
                                    marker: {
                                        color: '#8A8EF4',
                                        line: {
                                            color: 'white'
                                        }
                                    }
                                },
                                {
                                    x: [],
                                    y: [],
                                    name: 'Mixed feedback',
                                    key: 'mixedFeedback',
                                    hoverinfo: 'none',
                                    hovertemplate: '',
                                    type: 'bar',
                                    marker: {
                                        color: '#8A8EF4',
                                        line: {
                                            color: 'white'
                                        }
                                    }
                                }
                        ]
                        }
                },
                {
                    key: 'returningCustomerConversations',
                    suffixKey: 'ReturningCustomerConversations',
                    label: 'Returning customers',
                    subLabel: 'Returning customer converstions - positive, negative, no feedback and mixed feedback',
                    value: '34K',
                    selected: false,
                    changeOver30Days: 2.1,
                    changeFromStart: -2.1,
                    suffix:'',
                    chartData: [],
                    trendGraph: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:ct="http://gionkunz.github.com/chartist-js/ct" width="120" height="50" class="ct-chart-line" viewBox="0 4.042 120 45.333" preserveAspectRatio="none" style="width:120;height:50"><g class="ct-grids"></g><g><g class="ct-series ct-series-a"><path d="M0,16.667L0,16.667L3.243,16.667L6.486,16.667L9.73,8.875L12.973,13.708L16.216,10.542L19.459,16.667L22.703,16.667L25.946,16.667L29.189,16.667L32.432,16.667L35.676,16.667L38.919,6.125L42.162,11.375L45.405,16.625L48.649,11.708L51.892,11.292L55.135,16.667L58.378,16.667L61.622,16.667L64.865,16.667L68.108,4.125L71.351,12.375L74.595,12.708L77.838,16.667L81.081,16.667L84.324,16.667L87.568,16.667L90.811,16.667L94.054,16.667L97.297,4.042L100.541,11.208L103.784,13.708L107.027,13.375L110.27,16.667L113.514,16.667L116.757,16.667L120,16.667L120,16.667Z" class="ct-area"></path><path d="M0,16.667L3.243,16.667L6.486,16.667L9.73,8.875L12.973,13.708L16.216,10.542L19.459,16.667L22.703,16.667L25.946,16.667L29.189,16.667L32.432,16.667L35.676,16.667L38.919,6.125L42.162,11.375L45.405,16.625L48.649,11.708L51.892,11.292L55.135,16.667L58.378,16.667L61.622,16.667L64.865,16.667L68.108,4.125L71.351,12.375L74.595,12.708L77.838,16.667L81.081,16.667L84.324,16.667L87.568,16.667L90.811,16.667L94.054,16.667L97.297,4.042L100.541,11.208L103.784,13.708L107.027,13.375L110.27,16.667L113.514,16.667L116.757,16.667L120,16.667" class="ct-line"></path></g><g class="ct-series ct-series-b"><path d="M0,16.667L0,45.208L3.243,46.875L6.486,16.667L9.73,16.667L12.973,16.667L16.216,16.667L19.459,16.667L22.703,17.958L25.946,22.208L29.189,43.625L32.432,46.375L35.676,16.667L38.919,16.667L42.162,16.667L45.405,16.667L48.649,16.667L51.892,16.667L55.135,16.667L58.378,40.292L61.622,49.375L64.865,16.667L68.108,16.667L71.351,16.667L74.595,16.667L77.838,16.667L81.081,16.708L84.324,18.625L87.568,42.542L90.811,48.958L94.054,16.667L97.297,16.667L100.541,16.667L103.784,16.667L107.027,16.667L110.27,16.667L113.514,19.958L116.757,43.625L120,48.875L120,16.667Z" class="ct-area"></path><path d="M0,45.208L3.243,46.875L6.486,16.667L9.73,16.667L12.973,16.667L16.216,16.667L19.459,16.667L22.703,17.958L25.946,22.208L29.189,43.625L32.432,46.375L35.676,16.667L38.919,16.667L42.162,16.667L45.405,16.667L48.649,16.667L51.892,16.667L55.135,16.667L58.378,40.292L61.622,49.375L64.865,16.667L68.108,16.667L71.351,16.667L74.595,16.667L77.838,16.667L81.081,16.708L84.324,18.625L87.568,42.542L90.811,48.958L94.054,16.667L97.297,16.667L100.541,16.667L103.784,16.667L107.027,16.667L110.27,16.667L113.514,19.958L116.757,43.625L120,48.875" class="ct-line"></path></g><g class="ct-series ct-series-c"><path d="M0,16.667L0,23.455L3.243,23.477L6.486,23.487L9.73,23.498L12.973,23.52L16.216,23.541L19.459,23.552L22.703,23.563L25.946,23.584L29.189,23.606L32.432,23.627L35.676,23.638L38.919,23.648L42.162,23.67L45.405,23.691L48.649,23.713L51.892,23.734L55.135,23.745L58.378,23.756L61.622,23.777L64.865,23.788L68.108,23.799L71.351,23.82L74.595,23.842L77.838,23.853L81.081,23.863L84.324,23.885L87.568,23.906L90.811,23.928L94.054,23.939L97.297,23.949L100.541,23.971L103.784,23.992L107.027,24.014L110.27,24.025L113.514,24.035L116.757,24.057L120,24.078L120,16.667Z" class="ct-area"></path><path d="M0,23.455L3.243,23.477L6.486,23.487L9.73,23.498L12.973,23.52L16.216,23.541L19.459,23.552L22.703,23.563L25.946,23.584L29.189,23.606L32.432,23.627L35.676,23.638L38.919,23.648L42.162,23.67L45.405,23.691L48.649,23.713L51.892,23.734L55.135,23.745L58.378,23.756L61.622,23.777L64.865,23.788L68.108,23.799L71.351,23.82L74.595,23.842L77.838,23.853L81.081,23.863L84.324,23.885L87.568,23.906L90.811,23.928L94.054,23.939L97.297,23.949L100.541,23.971L103.784,23.992L107.027,24.014L110.27,24.025L113.514,24.035L116.757,24.057L120,24.078" class="ct-line"></path></g></g><g class="ct-labels"></g></svg>',
                    pieChartData: {
                    title: 'Returning customer converstions - positive, negative, no feedback and mixed feedback',
                    tooltips:'Any of the following conversations for the customer ID.',
                    labels: ['positive feedback', 'negative feedback', 'no feedback'],
                    values: [15, 20, 75],
                    displayValue: '600,000',
                    legends: ['Positive feedback', 'Negative feedback', 'No feedback']
                    },
                    columnChartData: {
                    // title: 'French conversations contained vs handed off',
                    legends: ['Positive feedback', 'Negative feedback', 'No feedback'],
                    traceData: [
                        {
                            x: [],
                            y: [],
                            name: 'Positive feedback',
                            key: 'positiveFeedback',
                            type: 'bar',
                            hoverinfo: 'none',
                            hovertemplate: '',
                            marker: {
                                color: '#0C2837',
                                line: {
                                    color: 'white'
                                }
                            }
                            },
                            {
                            x: [],
                            y: [],
                            name: 'Negative feedback',
                            key: 'negativeFeedback',
                            type: 'bar',
                            hoverinfo: 'none',
                            hovertemplate: '',
                            marker: {
                                color: '#4D50E8',
                                line: {
                                color: 'white'
                                }
                            }
                            },
                            {
                                x: [],
                                y: [],
                                name: 'no feedback',
                                key: 'noFeedback',
                                hoverinfo: 'none',
                                hovertemplate: '',
                                type: 'bar',
                                marker: {
                                    color: '#8A8EF4',
                                    line: {
                                        color: 'white'
                                    }
                                }
                            },
                            {
                                x: [],
                                y: [],
                                name: 'Mixed feedback',
                                key: 'mixedFeedback',
                                hoverinfo: 'none',
                                hovertemplate: '',
                                type: 'bar',
                                marker: {
                                    color: '#8A8EF4',
                                    line: {
                                        color: 'white'
                                    }
                                }
                            }
                    ]
                    }
                },
            ]
        }
    },
    
    getCustomerBehaviourUsagePerCustomerData() {
        return {
            label: 'Usage per Customer',
            tooltips: 'The average number of times that customers interacted <br/>with the virtual or live agent in the selected time frame.',
            filterSettings:{
                buckets: [
                    {
                        title:'Average conversations',
                        key: 'averageConversations',
                        suffix: '',
                        maxNumRange: 4,
                        numberRange: [
                            {
                            startNumber: 0,
                            endNumber: 1
                            },
                            {
                            startNumber: 1,
                            endNumber: 2
                            },
                            {
                            startNumber: 2,
                            endNumber: null
                            }
                        ]
                    },
                    {
                        title:'Lifetime conversations',
                        key: 'lifetimeConversations',
                        suffix: '',
                        maxNumRange: 4,
                        numberRange: [
                            {
                            startNumber: 0,
                            endNumber: 1
                            },
                            {
                            startNumber: 1,
                            endNumber: 2
                            },
                            {
                            startNumber: 2,
                            endNumber: null
                            }
                        ]
                    }
                ]
            },
            data: [
                {
                    key: 'averageConversations',
                    suffixKey: 'AverageConversations',
                    label: 'Avg. conversations',
                    subLabel: 'Average conversations - 1 conversation, 2 - 4 conversations, 5+ conversations',
                    value: '1.2',
                    selected: false,
                    multiChart: true,
                    changeOver30Days: 2.1,
                    changeFromStart: -2.1,
                    suffix:'',
                    chartData: [],
                    trendGraph: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:ct="http://gionkunz.github.com/chartist-js/ct" width="120" height="50" class="ct-chart-line" viewBox="0 4.042 120 45.333" preserveAspectRatio="none" style="width:120;height:50"><g class="ct-grids"></g><g><g class="ct-series ct-series-a"><path d="M0,16.667L0,16.667L3.243,16.667L6.486,16.667L9.73,8.875L12.973,13.708L16.216,10.542L19.459,16.667L22.703,16.667L25.946,16.667L29.189,16.667L32.432,16.667L35.676,16.667L38.919,6.125L42.162,11.375L45.405,16.625L48.649,11.708L51.892,11.292L55.135,16.667L58.378,16.667L61.622,16.667L64.865,16.667L68.108,4.125L71.351,12.375L74.595,12.708L77.838,16.667L81.081,16.667L84.324,16.667L87.568,16.667L90.811,16.667L94.054,16.667L97.297,4.042L100.541,11.208L103.784,13.708L107.027,13.375L110.27,16.667L113.514,16.667L116.757,16.667L120,16.667L120,16.667Z" class="ct-area"></path><path d="M0,16.667L3.243,16.667L6.486,16.667L9.73,8.875L12.973,13.708L16.216,10.542L19.459,16.667L22.703,16.667L25.946,16.667L29.189,16.667L32.432,16.667L35.676,16.667L38.919,6.125L42.162,11.375L45.405,16.625L48.649,11.708L51.892,11.292L55.135,16.667L58.378,16.667L61.622,16.667L64.865,16.667L68.108,4.125L71.351,12.375L74.595,12.708L77.838,16.667L81.081,16.667L84.324,16.667L87.568,16.667L90.811,16.667L94.054,16.667L97.297,4.042L100.541,11.208L103.784,13.708L107.027,13.375L110.27,16.667L113.514,16.667L116.757,16.667L120,16.667" class="ct-line"></path></g><g class="ct-series ct-series-b"><path d="M0,16.667L0,45.208L3.243,46.875L6.486,16.667L9.73,16.667L12.973,16.667L16.216,16.667L19.459,16.667L22.703,17.958L25.946,22.208L29.189,43.625L32.432,46.375L35.676,16.667L38.919,16.667L42.162,16.667L45.405,16.667L48.649,16.667L51.892,16.667L55.135,16.667L58.378,40.292L61.622,49.375L64.865,16.667L68.108,16.667L71.351,16.667L74.595,16.667L77.838,16.667L81.081,16.708L84.324,18.625L87.568,42.542L90.811,48.958L94.054,16.667L97.297,16.667L100.541,16.667L103.784,16.667L107.027,16.667L110.27,16.667L113.514,19.958L116.757,43.625L120,48.875L120,16.667Z" class="ct-area"></path><path d="M0,45.208L3.243,46.875L6.486,16.667L9.73,16.667L12.973,16.667L16.216,16.667L19.459,16.667L22.703,17.958L25.946,22.208L29.189,43.625L32.432,46.375L35.676,16.667L38.919,16.667L42.162,16.667L45.405,16.667L48.649,16.667L51.892,16.667L55.135,16.667L58.378,40.292L61.622,49.375L64.865,16.667L68.108,16.667L71.351,16.667L74.595,16.667L77.838,16.667L81.081,16.708L84.324,18.625L87.568,42.542L90.811,48.958L94.054,16.667L97.297,16.667L100.541,16.667L103.784,16.667L107.027,16.667L110.27,16.667L113.514,19.958L116.757,43.625L120,48.875" class="ct-line"></path></g><g class="ct-series ct-series-c"><path d="M0,16.667L0,23.455L3.243,23.477L6.486,23.487L9.73,23.498L12.973,23.52L16.216,23.541L19.459,23.552L22.703,23.563L25.946,23.584L29.189,23.606L32.432,23.627L35.676,23.638L38.919,23.648L42.162,23.67L45.405,23.691L48.649,23.713L51.892,23.734L55.135,23.745L58.378,23.756L61.622,23.777L64.865,23.788L68.108,23.799L71.351,23.82L74.595,23.842L77.838,23.853L81.081,23.863L84.324,23.885L87.568,23.906L90.811,23.928L94.054,23.939L97.297,23.949L100.541,23.971L103.784,23.992L107.027,24.014L110.27,24.025L113.514,24.035L116.757,24.057L120,24.078L120,16.667Z" class="ct-area"></path><path d="M0,23.455L3.243,23.477L6.486,23.487L9.73,23.498L12.973,23.52L16.216,23.541L19.459,23.552L22.703,23.563L25.946,23.584L29.189,23.606L32.432,23.627L35.676,23.638L38.919,23.648L42.162,23.67L45.405,23.691L48.649,23.713L51.892,23.734L55.135,23.745L58.378,23.756L61.622,23.777L64.865,23.788L68.108,23.799L71.351,23.82L74.595,23.842L77.838,23.853L81.081,23.863L84.324,23.885L87.568,23.906L90.811,23.928L94.054,23.939L97.297,23.949L100.541,23.971L103.784,23.992L107.027,24.014L110.27,24.025L113.514,24.035L116.757,24.057L120,24.078" class="ct-line"></path></g></g><g class="ct-labels"></g></svg>',
                    lineChartData: {
                        title: 'average conversations',
                        tooltips: '',
                        xAxisData: [],
                        yAxisData: [],
                        legends: ['average conversations'],
                        prefix:'',
                        suffix: ''
                    },
                    pieChartData: {
                    // title: 'Conversations split between languages',
                    labels: ['1 - 2 conversation', '3 - 4 conversations', '5+ conversations'],
                    tooltips:'',
                    values: [15, 20, 75],
                    displayValue: '1.2',
                    legends: ['1 - 2 conversation', '3 - 4 conversations', '5+ conversations'],
                    },
                    columnChartData: {
                    title: 'user volumes',
                    legends: ['1 - 2 conversation', '3 - 4 conversations', '5+ conversations'],
                    traceData: [
                        {
                        x: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
                        y: [20, 14, 23, 12, 32, 42, 43, 22, 21, 39, 40, 30],
                        name: '1 - 2 conversation',
                        type: 'bar',
                        hoverinfo: 'none',
                        hovertemplate: '',
                        marker: {
                            color: '#8A8EF4',
                            line: {
                                color: 'white'
                            }
                        }
                        },
                        {
                        x: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
                        y: [120, 14, 23, 12, 132, 42, 43, 22, 21, 39, 140, 30],
                        name: '3 - 4 conversations',
                        type: 'bar',
                        hoverinfo: 'none',
                        hovertemplate: '',
                        marker: {
                            color: '#4D50E8',
                            line: {
                            color: 'white'
                            }
                        }
                        },
                        {
                        x: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
                        y: [20, 14, 23, 12, 32, 42, 43, 22, 21, 39, 40, 30],
                        name: '5+ conversations',
                        type: 'bar',
                        hoverinfo: 'none',
                        hovertemplate: '',
                        marker: {
                            color: '#0C2837',
                            line: {
                            color: 'white'
                            }
                        }
                        }
                    ]
                    }
                },
                {
                    key: 'lifetimeConversations',
                    suffixKey: 'LifetimeConversations',
                    label: 'Lifetime conversations',
                    subLabel: 'Lifetime conversations - 1 conversation, 2 - 4 conversations, 5+ conversations',
                    value: '14.5',
                    selected: false,
                    multiChart: true,
                    changeOver30Days: 2.1,
                    changeFromStart: -2.1,
                    suffix:'',
                    chartData: [],
                    trendGraph: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:ct="http://gionkunz.github.com/chartist-js/ct" width="120" height="50" class="ct-chart-line" viewBox="0 0 120 29.032" preserveAspectRatio="none" style="width:120;height:50"><g class="ct-grids"></g><g><g class="ct-series ct-series-a"><path d="M0,25L0,25L4.138,25L8.276,25L12.414,25L16.552,25L20.69,25L24.828,25L28.966,25L33.103,25L37.241,25L41.379,25L45.517,25L49.655,25L53.793,25L57.931,25L62.069,25L66.207,25L70.345,25L74.483,25L78.621,25L82.759,25L86.897,25L91.034,25L95.172,25L99.31,25L103.448,25L107.586,25L111.724,0L115.862,0L120,0L120,25Z" class="ct-area"></path><path d="M0,25L4.138,25L8.276,25L12.414,25L16.552,25L20.69,25L24.828,25L28.966,25L33.103,25L37.241,25L41.379,25L45.517,25L49.655,25L53.793,25L57.931,25L62.069,25L66.207,25L70.345,25L74.483,25L78.621,25L82.759,25L86.897,25L91.034,25L95.172,25L99.31,25L103.448,25L107.586,25L111.724,0L115.862,0L120,0" class="ct-line"></path></g><g class="ct-series ct-series-b"><path d="M0,25L0,25L4.138,25L8.276,25L12.414,25L16.552,25L20.69,25L24.828,25L28.966,25L33.103,25L37.241,25L41.379,25L45.517,25L49.655,25L53.793,25L57.931,25L62.069,25L66.207,25L70.345,25L74.483,25L78.621,25L82.759,25L86.897,25L91.034,25L95.172,25L99.31,25L103.448,25L107.586,25L111.724,25L115.862,25L120,25L120,25Z" class="ct-area"></path><path d="M0,25L4.138,25L8.276,25L12.414,25L16.552,25L20.69,25L24.828,25L28.966,25L33.103,25L37.241,25L41.379,25L45.517,25L49.655,25L53.793,25L57.931,25L62.069,25L66.207,25L70.345,25L74.483,25L78.621,25L82.759,25L86.897,25L91.034,25L95.172,25L99.31,25L103.448,25L107.586,25L111.724,25L115.862,25L120,25" class="ct-line"></path></g><g class="ct-series ct-series-c"><path d="M0,25L0,29.032L4.138,28.582L8.276,28.131L12.414,27.681L16.552,27.23L20.69,26.78L24.828,26.329L28.966,25.879L33.103,25.428L37.241,24.978L41.379,24.527L45.517,24.077L49.655,23.626L53.793,23.176L57.931,22.725L62.069,22.275L66.207,21.824L70.345,21.374L74.483,20.923L78.621,20.473L82.759,20.022L86.897,19.572L91.034,19.121L95.172,18.671L99.31,18.22L103.448,17.77L107.586,17.319L111.724,16.869L115.862,16.418L120,15.968L120,25Z" class="ct-area"></path><path d="M0,29.032L4.138,28.582L8.276,28.131L12.414,27.681L16.552,27.23L20.69,26.78L24.828,26.329L28.966,25.879L33.103,25.428L37.241,24.978L41.379,24.527L45.517,24.077L49.655,23.626L53.793,23.176L57.931,22.725L62.069,22.275L66.207,21.824L70.345,21.374L74.483,20.923L78.621,20.473L82.759,20.022L86.897,19.572L91.034,19.121L95.172,18.671L99.31,18.22L103.448,17.77L107.586,17.319L111.724,16.869L115.862,16.418L120,15.968" class="ct-line"></path></g></g><g class="ct-labels"></g></svg>',
                    lineChartData: {
                        title: 'lifetime conversations',
                        tooltips: '',
                        xAxisData: [],
                        yAxisData: [],
                        legends: ['lifetime conversations'],
                        prefix:'',
                        suffix: ''
                    },
                    pieChartData: {
                    // title: 'English conversations - contained vs handed off',
                    labels:  ['1 - 2 conversation', '3 - 4 conversations', '5+ conversations'],
                    values: [15, 20, 75],
                    displayValue: '1.2',
                    legends: ['1 - 2 conversation', '3 - 4 conversations', '5+ conversations'],
                    },
                    columnChartData: {
                    // title: 'English conversations contained vs handed off',
                    legends:  ['1 - 2 conversation', '3 - 4 conversations', '5+ conversations'],
                    traceData: [
                    {
                        x: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
                        y: [20, 14, 23, 12, 32, 42, 43, 22, 21, 39, 40, 30],
                        name: '1 - 2 conversation',
                        type: 'bar',
                        hoverinfo: 'none',
                        hovertemplate: '',
                        marker: {
                            color: '#8A8EF4',
                            line: {
                                color: 'white'
                            }
                        }
                        },
                        {
                        x: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
                        y: [120, 14, 23, 12, 132, 42, 43, 22, 21, 39, 140, 30],
                        name: '3 - 4 conversations',
                        type: 'bar',
                        hoverinfo: 'none',
                        hovertemplate: '',
                        marker: {
                            color: '#4D50E8',
                            line: {
                            color: 'white'
                            }
                        }
                        },
                        {
                        x: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
                        y: [20, 14, 23, 12, 32, 42, 43, 22, 21, 39, 40, 30],
                        name: '5+ conversations',
                        type: 'bar',
                        hoverinfo: 'none',
                        hovertemplate: '',
                        marker: {
                            color: '#0C2837',
                            line: {
                            color: 'white'
                            }
                        }
                        }
                    ]
                    }
                
                }
            ]
        }
    },
    
    getCustomerBehaviourJourneyAndResponseFeedbackData() {
        return {
            label: 'Response Feedback',
            tooltips: '',
            data: [
                {
                    key: 'responseFeedback',
                    suffixKey: 'ResponseFeedback',
                    label: 'Response Feedback',
                    value: '83%',
                    selected: false,
                    changeOver30Days: 5.1,
                    changeFromStart: -5.1,
                    suffix:'%',
                    chartData: [],
                    trendGraph: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:ct="http://gionkunz.github.com/chartist-js/ct" width="120" height="50" class="ct-chart-line" viewBox="0 0 120 29.032" preserveAspectRatio="none" style="width:120;height:50"><g class="ct-grids"></g><g><g class="ct-series ct-series-a"><path d="M0,25L0,25L4.138,25L8.276,25L12.414,25L16.552,25L20.69,25L24.828,25L28.966,25L33.103,25L37.241,25L41.379,25L45.517,25L49.655,25L53.793,25L57.931,25L62.069,25L66.207,25L70.345,25L74.483,25L78.621,25L82.759,25L86.897,25L91.034,25L95.172,25L99.31,25L103.448,25L107.586,25L111.724,0L115.862,0L120,0L120,25Z" class="ct-area"></path><path d="M0,25L4.138,25L8.276,25L12.414,25L16.552,25L20.69,25L24.828,25L28.966,25L33.103,25L37.241,25L41.379,25L45.517,25L49.655,25L53.793,25L57.931,25L62.069,25L66.207,25L70.345,25L74.483,25L78.621,25L82.759,25L86.897,25L91.034,25L95.172,25L99.31,25L103.448,25L107.586,25L111.724,0L115.862,0L120,0" class="ct-line"></path></g><g class="ct-series ct-series-b"><path d="M0,25L0,25L4.138,25L8.276,25L12.414,25L16.552,25L20.69,25L24.828,25L28.966,25L33.103,25L37.241,25L41.379,25L45.517,25L49.655,25L53.793,25L57.931,25L62.069,25L66.207,25L70.345,25L74.483,25L78.621,25L82.759,25L86.897,25L91.034,25L95.172,25L99.31,25L103.448,25L107.586,25L111.724,25L115.862,25L120,25L120,25Z" class="ct-area"></path><path d="M0,25L4.138,25L8.276,25L12.414,25L16.552,25L20.69,25L24.828,25L28.966,25L33.103,25L37.241,25L41.379,25L45.517,25L49.655,25L53.793,25L57.931,25L62.069,25L66.207,25L70.345,25L74.483,25L78.621,25L82.759,25L86.897,25L91.034,25L95.172,25L99.31,25L103.448,25L107.586,25L111.724,25L115.862,25L120,25" class="ct-line"></path></g><g class="ct-series ct-series-c"><path d="M0,25L0,29.032L4.138,28.582L8.276,28.131L12.414,27.681L16.552,27.23L20.69,26.78L24.828,26.329L28.966,25.879L33.103,25.428L37.241,24.978L41.379,24.527L45.517,24.077L49.655,23.626L53.793,23.176L57.931,22.725L62.069,22.275L66.207,21.824L70.345,21.374L74.483,20.923L78.621,20.473L82.759,20.022L86.897,19.572L91.034,19.121L95.172,18.671L99.31,18.22L103.448,17.77L107.586,17.319L111.724,16.869L115.862,16.418L120,15.968L120,25Z" class="ct-area"></path><path d="M0,29.032L4.138,28.582L8.276,28.131L12.414,27.681L16.552,27.23L20.69,26.78L24.828,26.329L28.966,25.879L33.103,25.428L37.241,24.978L41.379,24.527L45.517,24.077L49.655,23.626L53.793,23.176L57.931,22.725L62.069,22.275L66.207,21.824L70.345,21.374L74.483,20.923L78.621,20.473L82.759,20.022L86.897,19.572L91.034,19.121L95.172,18.671L99.31,18.22L103.448,17.77L107.586,17.319L111.724,16.869L115.862,16.418L120,15.968" class="ct-line"></path></g></g><g class="ct-labels"></g></svg>',
                    // title: 'English conversations - contained vs handed off',
                    title: 'English conversations contained vs handed off',
                    tableDataTopPositiveResponses: {
                        first_label: 'Top positive responses: total: 1000,000',
                        second_label: 'Volume',
                        third_label: '% of total',
                        tooltips: '',
                        data: [
                            {
                            index: 1,
                            intentName: 'test sentence test sentence test sentence test sentence',
                            volume: '200,000',
                            totalVolume: '40'
                            },
                            {
                            index: 2,
                            intentName: 'test sentence test sentence test sentence test sentence',
                            volume: '200,000',
                            totalVolume: '40'
                            },
                            {
                            index: 3,
                            intentName: 'test sentence test sentence test sentence test sentence',
                            volume: '200,000',
                            totalVolume: '40'
                            },
                            {
                            index: 4,
                            intentName: 'test sentence test sentence test sentence test sentence',
                            volume: '200,000',
                            totalVolume: '40'
                            },
                            {
                            index: 5,
                            intentName: 'test sentence test sentence test sentence test sentence',
                            volume: '200,000',
                            totalVolume: '40'
                            },
                            {
                            index: 6,
                            intentName: 'test sentence test sentence test sentence test sentence',
                            volume: '200,000',
                            totalVolume: '40'
                            }
                        ]
                    },
                    tableDataTopNegativeResponses: {
                        first_label: 'Top negative responses: total: 1000,000',
                        second_label: 'Volume',
                        third_label: '% of total',
                        tooltips: '',
                        data: [
                            {
                            index: 1,
                            intentName: 'test sentence test sentence test sentence test sentence',
                            volume: '200,000',
                            totalVolume: '40'
                            },
                            {
                            index: 2,
                            intentName: 'test sentence test sentence test sentence test sentence',
                            volume: '200,000',
                            totalVolume: '40'
                            },
                            {
                            index: 3,
                            intentName: 'test sentence test sentence test sentence test sentence',
                            volume: '200,000',
                            totalVolume: '40'
                            },
                            {
                            index: 4,
                            intentName: 'test sentence test sentence test sentence test sentence',
                            volume: '200,000',
                            totalVolume: '40'
                            },
                            {
                            index: 5,
                            intentName: 'test sentence test sentence test sentence test sentence',
                            volume: '200,000',
                            totalVolume: '40'
                            },
                            {
                            index: 6,
                            intentName: 'test sentence test sentence test sentence test sentence',
                            volume: '200,000',
                            totalVolume: '40'
                            }
                        ]
                    }
                }
            ]
        }
    },
    
    getCustomerBehaviourCustomerLocationData() {
        return {
            label: 'Customer Location',
            tooltips: '',
            data: [
            {
                key: 'conversations',
                label: 'VA Conversations',
                value: '600K',
                selected: false,
                changeOver30Days: 2.3,
                changeFromStart: -2.3,
                suffix:'%',
                chartData: [],
                trendGraph: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:ct="http://gionkunz.github.com/chartist-js/ct" width="120" height="50" class="ct-chart-line" viewBox="0 4.042 120 45.333" preserveAspectRatio="none" style="width:120;height:50"><g class="ct-grids"></g><g><g class="ct-series ct-series-a"><path d="M0,16.667L0,16.667L3.243,16.667L6.486,16.667L9.73,8.875L12.973,13.708L16.216,10.542L19.459,16.667L22.703,16.667L25.946,16.667L29.189,16.667L32.432,16.667L35.676,16.667L38.919,6.125L42.162,11.375L45.405,16.625L48.649,11.708L51.892,11.292L55.135,16.667L58.378,16.667L61.622,16.667L64.865,16.667L68.108,4.125L71.351,12.375L74.595,12.708L77.838,16.667L81.081,16.667L84.324,16.667L87.568,16.667L90.811,16.667L94.054,16.667L97.297,4.042L100.541,11.208L103.784,13.708L107.027,13.375L110.27,16.667L113.514,16.667L116.757,16.667L120,16.667L120,16.667Z" class="ct-area"></path><path d="M0,16.667L3.243,16.667L6.486,16.667L9.73,8.875L12.973,13.708L16.216,10.542L19.459,16.667L22.703,16.667L25.946,16.667L29.189,16.667L32.432,16.667L35.676,16.667L38.919,6.125L42.162,11.375L45.405,16.625L48.649,11.708L51.892,11.292L55.135,16.667L58.378,16.667L61.622,16.667L64.865,16.667L68.108,4.125L71.351,12.375L74.595,12.708L77.838,16.667L81.081,16.667L84.324,16.667L87.568,16.667L90.811,16.667L94.054,16.667L97.297,4.042L100.541,11.208L103.784,13.708L107.027,13.375L110.27,16.667L113.514,16.667L116.757,16.667L120,16.667" class="ct-line"></path></g><g class="ct-series ct-series-b"><path d="M0,16.667L0,45.208L3.243,46.875L6.486,16.667L9.73,16.667L12.973,16.667L16.216,16.667L19.459,16.667L22.703,17.958L25.946,22.208L29.189,43.625L32.432,46.375L35.676,16.667L38.919,16.667L42.162,16.667L45.405,16.667L48.649,16.667L51.892,16.667L55.135,16.667L58.378,40.292L61.622,49.375L64.865,16.667L68.108,16.667L71.351,16.667L74.595,16.667L77.838,16.667L81.081,16.708L84.324,18.625L87.568,42.542L90.811,48.958L94.054,16.667L97.297,16.667L100.541,16.667L103.784,16.667L107.027,16.667L110.27,16.667L113.514,19.958L116.757,43.625L120,48.875L120,16.667Z" class="ct-area"></path><path d="M0,45.208L3.243,46.875L6.486,16.667L9.73,16.667L12.973,16.667L16.216,16.667L19.459,16.667L22.703,17.958L25.946,22.208L29.189,43.625L32.432,46.375L35.676,16.667L38.919,16.667L42.162,16.667L45.405,16.667L48.649,16.667L51.892,16.667L55.135,16.667L58.378,40.292L61.622,49.375L64.865,16.667L68.108,16.667L71.351,16.667L74.595,16.667L77.838,16.667L81.081,16.708L84.324,18.625L87.568,42.542L90.811,48.958L94.054,16.667L97.297,16.667L100.541,16.667L103.784,16.667L107.027,16.667L110.27,16.667L113.514,19.958L116.757,43.625L120,48.875" class="ct-line"></path></g><g class="ct-series ct-series-c"><path d="M0,16.667L0,23.455L3.243,23.477L6.486,23.487L9.73,23.498L12.973,23.52L16.216,23.541L19.459,23.552L22.703,23.563L25.946,23.584L29.189,23.606L32.432,23.627L35.676,23.638L38.919,23.648L42.162,23.67L45.405,23.691L48.649,23.713L51.892,23.734L55.135,23.745L58.378,23.756L61.622,23.777L64.865,23.788L68.108,23.799L71.351,23.82L74.595,23.842L77.838,23.853L81.081,23.863L84.324,23.885L87.568,23.906L90.811,23.928L94.054,23.939L97.297,23.949L100.541,23.971L103.784,23.992L107.027,24.014L110.27,24.025L113.514,24.035L116.757,24.057L120,24.078L120,16.667Z" class="ct-area"></path><path d="M0,23.455L3.243,23.477L6.486,23.487L9.73,23.498L12.973,23.52L16.216,23.541L19.459,23.552L22.703,23.563L25.946,23.584L29.189,23.606L32.432,23.627L35.676,23.638L38.919,23.648L42.162,23.67L45.405,23.691L48.649,23.713L51.892,23.734L55.135,23.745L58.378,23.756L61.622,23.777L64.865,23.788L68.108,23.799L71.351,23.82L74.595,23.842L77.838,23.853L81.081,23.863L84.324,23.885L87.568,23.906L90.811,23.928L94.054,23.939L97.297,23.949L100.541,23.971L103.784,23.992L107.027,24.014L110.27,24.025L113.514,24.035L116.757,24.057L120,24.078" class="ct-line"></path></g></g><g class="ct-labels"></g></svg>',
                pieChartData: {
                // title: 'Conversations split between languages',
                labels: ['English', 'French', 'Spanish'],
                vaues: [15, 20, 75],
                displayValue: '40%',
                legends: ['English', 'French', 'Spanish'],
                },
                columnChartData: {
                // title: 'Conversations split between languages',
                legends: ['English', 'French', 'Spanish'],
                traceData: [
                    {
                    x: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
                    y: [20, 14, 23, 12, 32, 42, 43, 22, 21, 39, 40, 30],
                    name: 'Spanish',
                    type: 'bar',
                    marker: {
                        color: '#8A8EF4',
                        line: {
                            color: 'white'
                        }
                    }
                    },
                    {
                    x: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
                    y: [120, 14, 23, 12, 132, 42, 43, 22, 21, 39, 140, 30],
                    name: 'French',
                    type: 'bar',
                    marker: {
                        color: '#4D50E8',
                        line: {
                        color: 'white'
                        }
                    }
                    },
                    {
                    x: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
                    y: [20, 14, 23, 12, 32, 42, 43, 22, 21, 39, 40, 30],
                    name: 'English',
                    type: 'bar',
                    marker: {
                        color: '#0C2837',
                        line: {
                        color: 'white'
                        }
                    }
                    }
                ]
                }
            },
            {
                key: 'conversationsByEnglish',
                suffixKey: 'ConversationsByEnglish',
                label: 'English',
                value: '500K',
                selected: false,
                changeOver30Days: 5.1,
                changeFromStart: -5.1,
                suffix:'%',
                chartData: [],
                trendGraph: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:ct="http://gionkunz.github.com/chartist-js/ct" width="120" height="50" class="ct-chart-line" viewBox="0 0 120 29.032" preserveAspectRatio="none" style="width:120;height:50"><g class="ct-grids"></g><g><g class="ct-series ct-series-a"><path d="M0,25L0,25L4.138,25L8.276,25L12.414,25L16.552,25L20.69,25L24.828,25L28.966,25L33.103,25L37.241,25L41.379,25L45.517,25L49.655,25L53.793,25L57.931,25L62.069,25L66.207,25L70.345,25L74.483,25L78.621,25L82.759,25L86.897,25L91.034,25L95.172,25L99.31,25L103.448,25L107.586,25L111.724,0L115.862,0L120,0L120,25Z" class="ct-area"></path><path d="M0,25L4.138,25L8.276,25L12.414,25L16.552,25L20.69,25L24.828,25L28.966,25L33.103,25L37.241,25L41.379,25L45.517,25L49.655,25L53.793,25L57.931,25L62.069,25L66.207,25L70.345,25L74.483,25L78.621,25L82.759,25L86.897,25L91.034,25L95.172,25L99.31,25L103.448,25L107.586,25L111.724,0L115.862,0L120,0" class="ct-line"></path></g><g class="ct-series ct-series-b"><path d="M0,25L0,25L4.138,25L8.276,25L12.414,25L16.552,25L20.69,25L24.828,25L28.966,25L33.103,25L37.241,25L41.379,25L45.517,25L49.655,25L53.793,25L57.931,25L62.069,25L66.207,25L70.345,25L74.483,25L78.621,25L82.759,25L86.897,25L91.034,25L95.172,25L99.31,25L103.448,25L107.586,25L111.724,25L115.862,25L120,25L120,25Z" class="ct-area"></path><path d="M0,25L4.138,25L8.276,25L12.414,25L16.552,25L20.69,25L24.828,25L28.966,25L33.103,25L37.241,25L41.379,25L45.517,25L49.655,25L53.793,25L57.931,25L62.069,25L66.207,25L70.345,25L74.483,25L78.621,25L82.759,25L86.897,25L91.034,25L95.172,25L99.31,25L103.448,25L107.586,25L111.724,25L115.862,25L120,25" class="ct-line"></path></g><g class="ct-series ct-series-c"><path d="M0,25L0,29.032L4.138,28.582L8.276,28.131L12.414,27.681L16.552,27.23L20.69,26.78L24.828,26.329L28.966,25.879L33.103,25.428L37.241,24.978L41.379,24.527L45.517,24.077L49.655,23.626L53.793,23.176L57.931,22.725L62.069,22.275L66.207,21.824L70.345,21.374L74.483,20.923L78.621,20.473L82.759,20.022L86.897,19.572L91.034,19.121L95.172,18.671L99.31,18.22L103.448,17.77L107.586,17.319L111.724,16.869L115.862,16.418L120,15.968L120,25Z" class="ct-area"></path><path d="M0,29.032L4.138,28.582L8.276,28.131L12.414,27.681L16.552,27.23L20.69,26.78L24.828,26.329L28.966,25.879L33.103,25.428L37.241,24.978L41.379,24.527L45.517,24.077L49.655,23.626L53.793,23.176L57.931,22.725L62.069,22.275L66.207,21.824L70.345,21.374L74.483,20.923L78.621,20.473L82.759,20.022L86.897,19.572L91.034,19.121L95.172,18.671L99.31,18.22L103.448,17.77L107.586,17.319L111.724,16.869L115.862,16.418L120,15.968" class="ct-line"></path></g></g><g class="ct-labels"></g></svg>',
                pieChartData: {
                // title: 'English conversations - contained vs handed off',
                labels: ['Contained', 'Handed off'],
                values: [15, 20, 75],
                displayValue: '600K',
                legends: ['Contained', 'Handed off'],
                },
                columnChartData: {
                // title: 'English conversations contained vs handed off',
                legends: ['Contained', 'Handed off'],
                traceData: [
                    {
                        x: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
                        y: [20, 34, 23, 12, 32, 42, 43, 22, 21, 39, 40, 30],
                        name: 'Contained',
                        type: 'bar',
                        marker: {
                            color: '#8A8EF4',
                            line: {
                                color: 'white'
                            }
                        }
                        },
                        {
                        x: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
                        y: [120, 14, 23, 12, 12, 12, 43, 22, 21, 39, 140, 30],
                        name: 'Handed off',
                        type: 'bar',
                        marker: {
                            color: '#4D50E8',
                            line: {
                            color: 'white'
                            }
                        }
                        }
                    ]
                    }
                },
                {
                    key: 'conversationsByFrench',
                    suffixKey: 'ConversationsByFrench',
                    label: 'French',
                    value: '40K',
                    selected: false,
                    changeOver30Days: 10.1,
                    changeFromStart: -10.1,
                    suffix:'%',
                    chartData: [],
                    trendGraph: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:ct="http://gionkunz.github.com/chartist-js/ct" width="120" height="50" class="ct-chart-line" viewBox="0 4.042 120 45.333" preserveAspectRatio="none" style="width:120;height:50"><g class="ct-grids"></g><g><g class="ct-series ct-series-a"><path d="M0,16.667L0,16.667L3.243,16.667L6.486,16.667L9.73,8.875L12.973,13.708L16.216,10.542L19.459,16.667L22.703,16.667L25.946,16.667L29.189,16.667L32.432,16.667L35.676,16.667L38.919,6.125L42.162,11.375L45.405,16.625L48.649,11.708L51.892,11.292L55.135,16.667L58.378,16.667L61.622,16.667L64.865,16.667L68.108,4.125L71.351,12.375L74.595,12.708L77.838,16.667L81.081,16.667L84.324,16.667L87.568,16.667L90.811,16.667L94.054,16.667L97.297,4.042L100.541,11.208L103.784,13.708L107.027,13.375L110.27,16.667L113.514,16.667L116.757,16.667L120,16.667L120,16.667Z" class="ct-area"></path><path d="M0,16.667L3.243,16.667L6.486,16.667L9.73,8.875L12.973,13.708L16.216,10.542L19.459,16.667L22.703,16.667L25.946,16.667L29.189,16.667L32.432,16.667L35.676,16.667L38.919,6.125L42.162,11.375L45.405,16.625L48.649,11.708L51.892,11.292L55.135,16.667L58.378,16.667L61.622,16.667L64.865,16.667L68.108,4.125L71.351,12.375L74.595,12.708L77.838,16.667L81.081,16.667L84.324,16.667L87.568,16.667L90.811,16.667L94.054,16.667L97.297,4.042L100.541,11.208L103.784,13.708L107.027,13.375L110.27,16.667L113.514,16.667L116.757,16.667L120,16.667" class="ct-line"></path></g><g class="ct-series ct-series-b"><path d="M0,16.667L0,45.208L3.243,46.875L6.486,16.667L9.73,16.667L12.973,16.667L16.216,16.667L19.459,16.667L22.703,17.958L25.946,22.208L29.189,43.625L32.432,46.375L35.676,16.667L38.919,16.667L42.162,16.667L45.405,16.667L48.649,16.667L51.892,16.667L55.135,16.667L58.378,40.292L61.622,49.375L64.865,16.667L68.108,16.667L71.351,16.667L74.595,16.667L77.838,16.667L81.081,16.708L84.324,18.625L87.568,42.542L90.811,48.958L94.054,16.667L97.297,16.667L100.541,16.667L103.784,16.667L107.027,16.667L110.27,16.667L113.514,19.958L116.757,43.625L120,48.875L120,16.667Z" class="ct-area"></path><path d="M0,45.208L3.243,46.875L6.486,16.667L9.73,16.667L12.973,16.667L16.216,16.667L19.459,16.667L22.703,17.958L25.946,22.208L29.189,43.625L32.432,46.375L35.676,16.667L38.919,16.667L42.162,16.667L45.405,16.667L48.649,16.667L51.892,16.667L55.135,16.667L58.378,40.292L61.622,49.375L64.865,16.667L68.108,16.667L71.351,16.667L74.595,16.667L77.838,16.667L81.081,16.708L84.324,18.625L87.568,42.542L90.811,48.958L94.054,16.667L97.297,16.667L100.541,16.667L103.784,16.667L107.027,16.667L110.27,16.667L113.514,19.958L116.757,43.625L120,48.875" class="ct-line"></path></g><g class="ct-series ct-series-c"><path d="M0,16.667L0,23.455L3.243,23.477L6.486,23.487L9.73,23.498L12.973,23.52L16.216,23.541L19.459,23.552L22.703,23.563L25.946,23.584L29.189,23.606L32.432,23.627L35.676,23.638L38.919,23.648L42.162,23.67L45.405,23.691L48.649,23.713L51.892,23.734L55.135,23.745L58.378,23.756L61.622,23.777L64.865,23.788L68.108,23.799L71.351,23.82L74.595,23.842L77.838,23.853L81.081,23.863L84.324,23.885L87.568,23.906L90.811,23.928L94.054,23.939L97.297,23.949L100.541,23.971L103.784,23.992L107.027,24.014L110.27,24.025L113.514,24.035L116.757,24.057L120,24.078L120,16.667Z" class="ct-area"></path><path d="M0,23.455L3.243,23.477L6.486,23.487L9.73,23.498L12.973,23.52L16.216,23.541L19.459,23.552L22.703,23.563L25.946,23.584L29.189,23.606L32.432,23.627L35.676,23.638L38.919,23.648L42.162,23.67L45.405,23.691L48.649,23.713L51.892,23.734L55.135,23.745L58.378,23.756L61.622,23.777L64.865,23.788L68.108,23.799L71.351,23.82L74.595,23.842L77.838,23.853L81.081,23.863L84.324,23.885L87.568,23.906L90.811,23.928L94.054,23.939L97.297,23.949L100.541,23.971L103.784,23.992L107.027,24.014L110.27,24.025L113.514,24.035L116.757,24.057L120,24.078" class="ct-line"></path></g></g><g class="ct-labels"></g></svg>',
                    pieChartData: {
                    // title: 'French conversations - contained vs handed off',
                    labels: ['Contained', 'Handed off'],
                    values: [15, 20, 75],
                    displayValue: '300K',
                    legends: ['Contained', 'Handed off'],
                    },
                    columnChartData: {
                    // title: 'French conversations contained vs handed off',
                    legends: ['Contained', 'Handed off'],
                    traceData: [
                        {
                        x: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
                        y: [20, 34, 23, 12, 32, 42, 43, 22, 21, 39, 40, 30],
                        name: 'Contained',
                        type: 'bar',
                        marker: {
                            color: '#8A8EF4',
                            line: {
                                color: 'white'
                            }
                        }
                        },
                        {
                        x: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
                        y: [120, 14, 23, 12, 12, 12, 43, 22, 21, 39, 140, 30],
                        name: 'Handed off',
                        type: 'bar',
                        marker: {
                            color: '#4D50E8',
                            line: {
                            color: 'white'
                            }
                        }
                        }
                    ]
                    }
                },
                {
                    key: 'conversationsBySpanish',
                    suffixKey: 'ConversationsBySpanish',
                    label: 'Spanish',
                    value: '20K',
                    selected: false,
                    changeOver30Days: 1.1,
                    changeFromStart: -1.1,
                    suffix:'%',
                    chartData: [],
                    trendGraph: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:ct="http://gionkunz.github.com/chartist-js/ct" width="120" height="50" class="ct-chart-line" viewBox="0 0 120 29.032" preserveAspectRatio="none" style="width:120;height:50"><g class="ct-grids"></g><g><g class="ct-series ct-series-a"><path d="M0,25L0,25L4.138,25L8.276,25L12.414,25L16.552,25L20.69,25L24.828,25L28.966,25L33.103,25L37.241,25L41.379,25L45.517,25L49.655,25L53.793,25L57.931,25L62.069,25L66.207,25L70.345,25L74.483,25L78.621,25L82.759,25L86.897,25L91.034,25L95.172,25L99.31,25L103.448,25L107.586,25L111.724,0L115.862,0L120,0L120,25Z" class="ct-area"></path><path d="M0,25L4.138,25L8.276,25L12.414,25L16.552,25L20.69,25L24.828,25L28.966,25L33.103,25L37.241,25L41.379,25L45.517,25L49.655,25L53.793,25L57.931,25L62.069,25L66.207,25L70.345,25L74.483,25L78.621,25L82.759,25L86.897,25L91.034,25L95.172,25L99.31,25L103.448,25L107.586,25L111.724,0L115.862,0L120,0" class="ct-line"></path></g><g class="ct-series ct-series-b"><path d="M0,25L0,25L4.138,25L8.276,25L12.414,25L16.552,25L20.69,25L24.828,25L28.966,25L33.103,25L37.241,25L41.379,25L45.517,25L49.655,25L53.793,25L57.931,25L62.069,25L66.207,25L70.345,25L74.483,25L78.621,25L82.759,25L86.897,25L91.034,25L95.172,25L99.31,25L103.448,25L107.586,25L111.724,25L115.862,25L120,25L120,25Z" class="ct-area"></path><path d="M0,25L4.138,25L8.276,25L12.414,25L16.552,25L20.69,25L24.828,25L28.966,25L33.103,25L37.241,25L41.379,25L45.517,25L49.655,25L53.793,25L57.931,25L62.069,25L66.207,25L70.345,25L74.483,25L78.621,25L82.759,25L86.897,25L91.034,25L95.172,25L99.31,25L103.448,25L107.586,25L111.724,25L115.862,25L120,25" class="ct-line"></path></g><g class="ct-series ct-series-c"><path d="M0,25L0,29.032L4.138,28.582L8.276,28.131L12.414,27.681L16.552,27.23L20.69,26.78L24.828,26.329L28.966,25.879L33.103,25.428L37.241,24.978L41.379,24.527L45.517,24.077L49.655,23.626L53.793,23.176L57.931,22.725L62.069,22.275L66.207,21.824L70.345,21.374L74.483,20.923L78.621,20.473L82.759,20.022L86.897,19.572L91.034,19.121L95.172,18.671L99.31,18.22L103.448,17.77L107.586,17.319L111.724,16.869L115.862,16.418L120,15.968L120,25Z" class="ct-area"></path><path d="M0,29.032L4.138,28.582L8.276,28.131L12.414,27.681L16.552,27.23L20.69,26.78L24.828,26.329L28.966,25.879L33.103,25.428L37.241,24.978L41.379,24.527L45.517,24.077L49.655,23.626L53.793,23.176L57.931,22.725L62.069,22.275L66.207,21.824L70.345,21.374L74.483,20.923L78.621,20.473L82.759,20.022L86.897,19.572L91.034,19.121L95.172,18.671L99.31,18.22L103.448,17.77L107.586,17.319L111.724,16.869L115.862,16.418L120,15.968" class="ct-line"></path></g></g><g class="ct-labels"></g></svg>',
                    pieChartData: {
                    // title: 'Spanish conversations - contained vs handed off',
                    labels: ['Contained', 'Handed off'],
                    values: [25, 75],
                    displayValue: '$200K',
                    legends: ['Contained', 'Handed off'],
                    },
                    columnChartData: {
                    // title: 'Spanish conversations contained vs handed off',
                    legends: ['Contained', 'Handed off'],
                    traceData: [
                        {
                        x: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
                        y: [20, 34, 23, 12, 32, 42, 43, 22, 21, 39, 40, 30],
                        name: 'Contained',
                        type: 'bar',
                        marker: {
                            color: '#8A8EF4',
                            line: {
                                color: 'white'
                            }
                        }
                        },
                        {
                        x: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
                        y: [20, 14, 23, 12, 52, 42, 43, 22, 21, 39, 70, 30],
                        name: 'Handed off',
                        type: 'bar',
                        marker: {
                            color: '#4D50E8',
                            line: {
                            color: 'white'
                            }
                        }
                        }
                    ]
                    }
                }
            ]
        }
    },
    
    
    getMockData() {
        return {
        //customer feedback
        customerFeedback: {
            
        },
        //Live Agent Handling
        liveAgentHandling: {
            "liveAgentHandling": {
                "averageHandlingTime": 61000,
                "averageResponseTime": 53200,
                "averageWaitTime": 121200,
                "liveAgentHandlingOvertime": {
                    "daysOvertimeRange": 35,
                    "daysPreviousAverageHandlingTime": 0,
                    "daysCurrentAverageHandlingTime": 61000,
                    "daysOvertimeRangeAverageHandlingTime": 100,
                    "daysPreviousAverageResponseTime": 0,
                    "daysCurrentAverageResponseTime": 53200,
                    "daysOvertimeRangeAverageResponseTime": 100,
                    "daysPreviousAverageWaitTime": 0,
                    "daysCurrentAverageWaitTime": 121200,
                    "daysOvertimeRangeAverageWaitTime": 100
                },
                "dailyData": [
                    {
                        "date": "2021-02-01",
                        "conversations": [
                            {
                                "handlingTime": 61000,
                                "responseTime": 53200,
                                "waitTime": 121200
                            }
                        ],
                        "averageHandlingTime": 61000,
                        "averageResponseTime": 53200,
                        "averageWaitTime": 121200
                    },
                    {
                        "date": "2021-02-02",
                        "conversations": [
                            {
                                "handlingTime": 161000,
                                "responseTime": 153200,
                                "waitTime": 1121200
                            }
                        ],
                        "averageHandlingTime": 1461000,
                        "averageResponseTime": 1453200,
                        "averageWaitTime": 14121200
                    },
                    {
                        "date": "2021-02-03",
                        "conversations": [
                            {
                                "handlingTime": 61000,
                                "responseTime": 53200,
                                "waitTime": 121200
                            }
                        ],
                        "averageHandlingTime": 2261000,
                        "averageResponseTime": 523200,
                        "averageWaitTime": 7221200
                    },
                    {
                        "date": "2021-02-04",
                        "conversations": [
                            {
                                "handlingTime": 621000,
                                "responseTime": 523200,
                                "waitTime": 21200
                            }
                        ],
                        "averageHandlingTime": 631000,
                        "averageResponseTime": 523200,
                        "averageWaitTime": 1221200
                    }
                ],
                "averageHandlingTimeTrendGraph": "<svg xmlns:ct=\"http://gionkunz.github.com/chartist-js/ct\" width=\"120\" height=\"50\" class=\"ct-chart-line\" style=\"width: 120; height: 50;\" viewBox=\"0 25 120 50\" preserveAspectRatio=\"none\"><g class=\"ct-grids\"></g><g><g class=\"ct-series ct-series-a\"><path d=\"M0,50L0,50L30,50L60,50L90,50L120,50L120,50Z\" class=\"ct-area\"></path><path d=\"M0,50L30,50L60,50L90,50L120,50\" class=\"ct-line\"></path></g><g class=\"ct-series ct-series-b\"><path d=\"M0,50L0,50L30,50L60,50L90,50L120,50L120,50Z\" class=\"ct-area\"></path><path d=\"M0,50L30,50L60,50L90,50L120,50\" class=\"ct-line\"></path></g><g class=\"ct-series ct-series-c\"><path d=\"M0,50L0,50L30,50L60,50L90,50L120,50L120,50Z\" class=\"ct-area\"></path><path d=\"M0,50L30,50L60,50L90,50L120,50\" class=\"ct-line\"></path></g></g><g class=\"ct-labels\"></g></svg>",
                "averageResponseTimeTrendGraph": "<svg xmlns:ct=\"http://gionkunz.github.com/chartist-js/ct\" width=\"120\" height=\"50\" class=\"ct-chart-line\" style=\"width: 120; height: 50;\" viewBox=\"0 25 120 50\" preserveAspectRatio=\"none\"><g class=\"ct-grids\"></g><g><g class=\"ct-series ct-series-a\"><path d=\"M0,50L0,50L30,50L60,50L90,50L120,50L120,50Z\" class=\"ct-area\"></path><path d=\"M0,50L30,50L60,50L90,50L120,50\" class=\"ct-line\"></path></g><g class=\"ct-series ct-series-b\"><path d=\"M0,50L0,50L30,50L60,50L90,50L120,50L120,50Z\" class=\"ct-area\"></path><path d=\"M0,50L30,50L60,50L90,50L120,50\" class=\"ct-line\"></path></g><g class=\"ct-series ct-series-c\"><path d=\"M0,50L0,50L30,50L60,50L90,50L120,50L120,50Z\" class=\"ct-area\"></path><path d=\"M0,50L30,50L60,50L90,50L120,50\" class=\"ct-line\"></path></g></g><g class=\"ct-labels\"></g></svg>",
                "averageWaitTimeTrendGraph": "<svg xmlns:ct=\"http://gionkunz.github.com/chartist-js/ct\" width=\"120\" height=\"50\" class=\"ct-chart-line\" style=\"width: 120; height: 50;\" viewBox=\"0 25 120 50\" preserveAspectRatio=\"none\"><g class=\"ct-grids\"></g><g><g class=\"ct-series ct-series-a\"><path d=\"M0,50L0,50L30,50L60,50L90,50L120,50L120,50Z\" class=\"ct-area\"></path><path d=\"M0,50L30,50L60,50L90,50L120,50\" class=\"ct-line\"></path></g><g class=\"ct-series ct-series-b\"><path d=\"M0,50L0,50L30,50L60,50L90,50L120,50L120,50Z\" class=\"ct-area\"></path><path d=\"M0,50L30,50L60,50L90,50L120,50\" class=\"ct-line\"></path></g><g class=\"ct-series ct-series-c\"><path d=\"M0,50L0,50L30,50L60,50L90,50L120,50L120,50Z\" class=\"ct-area\"></path><path d=\"M0,50L30,50L60,50L90,50L120,50\" class=\"ct-line\"></path></g></g><g class=\"ct-labels\"></g></svg>"
            }
        },
        tableDataTopPositiveJourneyResponses: {
            first_label: 'Top positive journey responses: total: 1000,000',
            second_label: 'Volume',
            third_label: '% of total',
            tooltips: '',
            data: [
                    {
                    index: 1,
                    intentName: 'test sentence test sentence test sentence test sentence',
                    volume: '200,000',
                    totalVolume: '40'
                    },
                    {
                    index: 2,
                    intentName: 'test sentence test sentence test sentence test sentence',
                    volume: '200,000',
                    totalVolume: '40'
                    },
                    {
                    index: 3,
                    intentName: 'test sentence test sentence test sentence test sentence',
                    volume: '200,000',
                    totalVolume: '40'
                    },
                    {
                    index: 4,
                    intentName: 'test sentence test sentence test sentence test sentence',
                    volume: '200,000',
                    totalVolume: '40'
                    },
                    {
                    index: 5,
                    intentName: 'test sentence test sentence test sentence test sentence',
                    volume: '200,000',
                    totalVolume: '40'
                    },
                    {
                    index: 6,
                    intentName: 'test sentence test sentence test sentence test sentence',
                    volume: '200,000',
                    totalVolume: '40'
                    },
                    {
                    index: 7,
                    intentName: 'test sentence test sentence test sentence test sentence',
                    volume: '200,000',
                    totalVolume: '40'
                    },
                    {
                    index: 8,
                    intentName: 'test sentence test sentence test sentence test sentence',
                    volume: '200,000',
                    totalVolume: '40'
                    },
                    {
                    index: 9,
                    intentName: 'test sentence test sentence test sentence test sentence',
                    volume: '200,000',
                    totalVolume: '40'
                    },
                    {
                    index: 10,
                    intentName: 'test sentence test sentence test sentence test sentence',
                    volume: '200,000',
                    totalVolume: '40'
                    },
                    {
                    index: 11,
                    intentName: 'test sentence test sentence test sentence test sentence',
                    volume: '200,000',
                    totalVolume: '40'
                    },
                    {
                    index: 12,
                    intentName: 'test sentence test sentence test sentence test sentence',
                    volume: '200,000',
                    totalVolume: '40'
                    },
    
                ]
            },
            //TopnegativesitiveJourneyResponses
            tableDataTopNegativeJourneyResponses: {
            first_label: 'Top negative journey responses: total: 1000,000',
            second_label: 'Volume',
            third_label: '% of total',
            tooltips: '',
            data: [
                {
                index: 1,
                intentName: 'test sentence test sentence test sentence test sentence',
                volume: '200,000',
                totalVolume: '40'
                },
                {
                index: 2,
                intentName: 'test sentence test sentence test sentence test sentence',
                volume: '200,000',
                totalVolume: '40'
                },
                {
                index: 3,
                intentName: 'test sentence test sentence test sentence test sentence',
                volume: '200,000',
                totalVolume: '40'
                },
                {
                index: 4,
                intentName: 'test sentence test sentence test sentence test sentence',
                volume: '200,000',
                totalVolume: '40'
                },
                {
                index: 5,
                intentName: 'test sentence test sentence test sentence test sentence',
                volume: '200,000',
                totalVolume: '40'
                },
                {
                index: 6,
                intentName: 'test sentence test sentence test sentence test sentence',
                volume: '200,000',
                totalVolume: '40'
                },
                {
                index: 7,
                intentName: 'test sentence test sentence test sentence test sentence',
                volume: '200,000',
                totalVolume: '40'
                },
                {
                index: 8,
                intentName: 'test sentence test sentence test sentence test sentence',
                volume: '200,000',
                totalVolume: '40'
                },
                {
                index: 9,
                intentName: 'test sentence test sentence test sentence test sentence',
                volume: '200,000',
                totalVolume: '40'
                },
                {
                index: 10,
                intentName: 'test sentence test sentence test sentence test sentence',
                volume: '200,000',
                totalVolume: '40'
                },
                {
                index: 11,
                intentName: 'test sentence test sentence test sentence test sentence',
                volume: '200,000',
                totalVolume: '40'
                },
                {
                index: 12,
                intentName: 'test sentence test sentence test sentence test sentence',
                volume: '200,000',
                totalVolume: '40'
                },
    
            ]
            },
            // tableDataAllIntents: {
            // label: 'All Intents',
            // tooltips: '',
            // data: [
            //     {
            //     index: 1,
            //     intentName: 'test sentence test sentence test sentence test sentence',
            //     volume: '200,000',
            //     totalVolume: '40'
            //     },
            //     {
            //     index: 2,
            //     intentName: 'test sentence test sentence test sentence test sentence',
            //     volume: '200,000',
            //     totalVolume: '40'
            //     },
            //     {
            //     index: 3,
            //     intentName: 'test sentence test sentence test sentence test sentence',
            //     volume: '200,000',
            //     totalVolume: '40'
            //     },
            //     {
            //     index: 4,
            //     intentName: 'test sentence test sentence test sentence test sentence',
            //     volume: '200,000',
            //     totalVolume: '40'
            //     },
            //     {
            //     index: 5,
            //     intentName: 'test sentence test sentence test sentence test sentence',
            //     volume: '200,000',
            //     totalVolume: '40'
            //     },
            //     {
            //     index: 6,
            //     intentName: 'test sentence test sentence test sentence test sentence',
            //     volume: '200,000',
            //     totalVolume: '40'
            //     },
            //     {
            //     index: 7,
            //     intentName: 'test sentence test sentence test sentence test sentence',
            //     volume: '200,000',
            //     totalVolume: '40'
            //     },
            //     {
            //     index: 8,
            //     intentName: 'test sentence test sentence test sentence test sentence',
            //     volume: '200,000',
            //     totalVolume: '40'
            //     },
            //     {
            //     index: 9,
            //     intentName: 'test sentence test sentence test sentence test sentence',
            //     volume: '200,000',
            //     totalVolume: '40'
            //     },
            //     {
            //     index: 10,
            //     intentName: 'test sentence test sentence test sentence test sentence',
            //     volume: '200,000',
            //     totalVolume: '40'
            //     },
            //     {
            //     index: 11,
            //     intentName: 'test sentence test sentence test sentence test sentence',
            //     volume: '200,000',
            //     totalVolume: '40'
            //     },
            //     {
            //     index: 12,
            //     intentName: 'test sentence test sentence test sentence test sentence',
            //     volume: '200,000',
            //     totalVolume: '40'
            //     },
    
            // ]
            // },
            //heading table data
            tableDataCountry: {
            first_label: 'Country',
            second_label: 'Users',
            third_label: '% Users',
            tooltips: '',
            data: [
                {
                index: 1,
                intentName: 'Canada',
                volume: '200,000',
                totalVolume: '40'
                },
                {
                index: 2,
                intentName: 'USA',
                volume: '200,000',
                totalVolume: '40'
                },
                {
                index: 3,
                intentName: 'UK',
                volume: '200,000',
                totalVolume: '40'
                },
                {
                index: 4,
                intentName: 'Country Name',
                volume: '200,000',
                totalVolume: '40'
                },
                {
                index: 5,
                intentName: 'Country Name',
                volume: '200,000',
                totalVolume: '40'
                },
                {
                index: 6,
                intentName: 'Country Name',
                volume: '200,000',
                totalVolume: '40'
                },
                {
                index: 7,
                intentName: 'Country Name',
                volume: '200,000',
                totalVolume: '40'
                },
                {
                index: 8,
                intentName: 'Country Name',
                volume: '200,000',
                totalVolume: '40'
                },
                {
                index: 9,
                intentName: 'Country Name',
                volume: '200,000',
                totalVolume: '40'
                },
                {
                index: 10,
                intentName: 'Country Name',
                volume: '200,000',
                totalVolume: '40'
                },
                {
                index: 11,
                intentName: 'Country Name',
                volume: '200,000',
                totalVolume: '40'
                },
                {
                index: 12,
                intentName: 'Country Name',
                volume: '200,000',
                totalVolume: '40'
                },
    
            ]
            },
            tableDataAllIntents: {
            label: 'All Intents',
            tooltips: '',
            data: [
                {
                index: 1,
                intentName: 'test sentence test sentence test sentence test sentence',
                volume: '200,000',
                totalVolume: '40'
                },
                {
                index: 2,
                intentName: 'test sentence test sentence test sentence test sentence',
                volume: '200,000',
                totalVolume: '40'
                },
                {
                index: 3,
                intentName: 'test sentence test sentence test sentence test sentence',
                volume: '200,000',
                totalVolume: '40'
                },
                {
                index: 4,
                intentName: 'test sentence test sentence test sentence test sentence',
                volume: '200,000',
                totalVolume: '40'
                },
                {
                index: 5,
                intentName: 'test sentence test sentence test sentence test sentence',
                volume: '200,000',
                totalVolume: '40'
                },
                {
                index: 6,
                intentName: 'test sentence test sentence test sentence test sentence',
                volume: '200,000',
                totalVolume: '40'
                },
                {
                index: 7,
                intentName: 'test sentence test sentence test sentence test sentence',
                volume: '200,000',
                totalVolume: '40'
                },
                {
                index: 8,
                intentName: 'test sentence test sentence test sentence test sentence',
                volume: '200,000',
                totalVolume: '40'
                },
                {
                index: 9,
                intentName: 'test sentence test sentence test sentence test sentence',
                volume: '200,000',
                totalVolume: '40'
                },
                {
                index: 10,
                intentName: 'test sentence test sentence test sentence test sentence',
                volume: '200,000',
                totalVolume: '40'
                },
                {
                index: 11,
                intentName: 'test sentence test sentence test sentence test sentence',
                volume: '200,000',
                totalVolume: '40'
                },
                {
                index: 12,
                intentName: 'test sentence test sentence test sentence test sentence',
                volume: '200,000',
                totalVolume: '40'
                },
    
            ]
            },
            //Intents Contained
            tableDataIntentsContained: {
            label: 'Intent Contained',
            tooltips: '',
            data: [
                {
                index: 1,
                intentName: 'test sentence test sentence test sentence test sentence',
                volume: '200,000',
                totalVolume: '40'
                },
                {
                index: 2,
                intentName: 'test sentence test sentence test sentence test sentence',
                volume: '200,000',
                totalVolume: '40'
                },
                {
                index: 3,
                intentName: 'test sentence test sentence test sentence test sentence',
                volume: '200,000',
                totalVolume: '40'
                },
                {
                index: 4,
                intentName: 'test sentence test sentence test sentence test sentence',
                volume: '200,000',
                totalVolume: '40'
                },
                {
                index: 5,
                intentName: 'test sentence test sentence test sentence test sentence',
                volume: '200,000',
                totalVolume: '40'
                },
                {
                index: 6,
                intentName: 'test sentence test sentence test sentence test sentence',
                volume: '200,000',
                totalVolume: '40'
                },
                {
                index: 7,
                intentName: 'test sentence test sentence test sentence test sentence',
                volume: '200,000',
                totalVolume: '40'
                },
                {
                index: 8,
                intentName: 'test sentence test sentence test sentence test sentence',
                volume: '200,000',
                totalVolume: '40'
                },
                {
                index: 9,
                intentName: 'test sentence test sentence test sentence test sentence',
                volume: '200,000',
                totalVolume: '40'
                },
                {
                index: 10,
                intentName: 'test sentence test sentence test sentence test sentence',
                volume: '200,000',
                totalVolume: '40'
                },
                {
                index: 11,
                intentName: 'test sentence test sentence test sentence test sentence',
                volume: '200,000',
                totalVolume: '40'
                },
                {
                index: 12,
                intentName: 'test sentence test sentence test sentence test sentence',
                volume: '200,000',
                totalVolume: '40'
                },
    
            ]
            },
        //Journey And Response Feedback
        journeyAndResponseFeedback: {
            
        },
        //customer location
        customerLocation: {
            
        },
         //conversations by devicws
        conversationsByDevices: {
            
        },
        //conversations by channels
        conversationsByChannels: {
            
        },
        //new and returning customers
        newAndReturningCustomers: {
            
        },
        //usage per customer
        usagePerCustomer: {
            usagePerCustomer: {
                "averageConversations": 2,
                "lifetimeConversations": 12,
                "averageConversationsTrendgraph": "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:ct=\"http://gionkunz.github.com/chartist-js/ct\" width=\"120\" height=\"50\" class=\"ct-chart-line\" viewBox=\"0 0 120 35.714\" preserveAspectRatio=\"none\" style=\"width:120;height:50\"><g class=\"ct-grids\"></g><g><g class=\"ct-series ct-series-a\"><path d=\"M0,0L0,0L24,0L48,0L72,0L96,0L120,0L120,0Z\" class=\"ct-area\"></path><path d=\"M0,0L24,0L48,0L72,0L96,0L120,0\" class=\"ct-line\"></path></g><g class=\"ct-series ct-series-b\"><path d=\"M0,0L0,0L24,0L48,35.714L72,0L96,0L120,0L120,0Z\" class=\"ct-area\"></path><path d=\"M0,0L24,0L48,35.714L72,0L96,0L120,0\" class=\"ct-line\"></path></g><g class=\"ct-series ct-series-c\"><path d=\"M0,0L0,8.503L24,7.483L48,6.463L72,5.442L96,4.422L120,3.401L120,0Z\" class=\"ct-area\"></path><path d=\"M0,8.503L24,7.483L48,6.463L72,5.442L96,4.422L120,3.401\" class=\"ct-line\"></path></g></g><g class=\"ct-labels\"></g></svg>",
                "lifetimeConversationsTrendgraph": "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:ct=\"http://gionkunz.github.com/chartist-js/ct\" width=\"120\" height=\"50\" class=\"ct-chart-line\" viewBox=\"0 18.065 120 31.935\" preserveAspectRatio=\"none\" style=\"width:120;height:50\"><g class=\"ct-grids\"></g><g><g class=\"ct-series ct-series-a\"><path d=\"M0,25L0,25L2.857,25L5.714,25L8.571,25L11.429,25L14.286,25L17.143,25L20,25L22.857,25L25.714,25L28.571,25L31.429,25L34.286,25L37.143,25L40,25L42.857,25L45.714,25L48.571,25L51.429,25L54.286,25L57.143,25L60,25L62.857,25L65.714,25L68.571,25L71.429,25L74.286,25L77.143,25L80,25L82.857,25L85.714,25L88.571,25L91.429,25L94.286,25L97.143,25L100,25L102.857,25L105.714,25L108.571,25L111.429,25L114.286,25L117.143,25L120,25L120,25Z\" class=\"ct-area\"></path><path d=\"M0,25L2.857,25L5.714,25L8.571,25L11.429,25L14.286,25L17.143,25L20,25L22.857,25L25.714,25L28.571,25L31.429,25L34.286,25L37.143,25L40,25L42.857,25L45.714,25L48.571,25L51.429,25L54.286,25L57.143,25L60,25L62.857,25L65.714,25L68.571,25L71.429,25L74.286,25L77.143,25L80,25L82.857,25L85.714,25L88.571,25L91.429,25L94.286,25L97.143,25L100,25L102.857,25L105.714,25L108.571,25L111.429,25L114.286,25L117.143,25L120,25\" class=\"ct-line\"></path></g><g class=\"ct-series ct-series-b\"><path d=\"M0,25L0,25L2.857,28.571L5.714,25L8.571,28.571L11.429,25L14.286,25L17.143,25L20,25L22.857,25L25.714,25L28.571,25L31.429,25L34.286,25L37.143,25L40,25L42.857,25L45.714,25L48.571,25L51.429,25L54.286,25L57.143,25L60,25L62.857,25L65.714,25L68.571,25L71.429,25L74.286,25L77.143,25L80,50L82.857,50L85.714,50L88.571,50L91.429,50L94.286,50L97.143,50L100,50L102.857,50L105.714,50L108.571,50L111.429,42.857L114.286,50L117.143,50L120,46.429L120,25Z\" class=\"ct-area\"></path><path d=\"M0,25L2.857,28.571L5.714,25L8.571,28.571L11.429,25L14.286,25L17.143,25L20,25L22.857,25L25.714,25L28.571,25L31.429,25L34.286,25L37.143,25L40,25L42.857,25L45.714,25L48.571,25L51.429,25L54.286,25L57.143,25L60,25L62.857,25L65.714,25L68.571,25L71.429,25L74.286,25L77.143,25L80,50L82.857,50L85.714,50L88.571,50L91.429,50L94.286,50L97.143,50L100,50L102.857,50L105.714,50L108.571,50L111.429,42.857L114.286,50L117.143,50L120,46.429\" class=\"ct-line\"></path></g><g class=\"ct-series ct-series-c\"><path d=\"M0,25L0,18.065L2.857,18.806L5.714,19.548L8.571,20.29L11.429,21.031L14.286,21.773L17.143,22.514L20,23.256L22.857,23.997L25.714,24.739L28.571,25.481L31.429,26.222L34.286,26.964L37.143,27.705L40,28.447L42.857,29.188L45.714,29.93L48.571,30.672L51.429,31.413L54.286,32.155L57.143,32.896L60,33.638L62.857,34.379L65.714,35.121L68.571,35.863L71.429,36.604L74.286,37.346L77.143,38.087L80,38.829L82.857,39.57L85.714,40.312L88.571,41.054L91.429,41.795L94.286,42.537L97.143,43.278L100,44.02L102.857,44.762L105.714,45.503L108.571,46.245L111.429,46.986L114.286,47.728L117.143,48.469L120,49.211L120,25Z\" class=\"ct-area\"></path><path d=\"M0,18.065L2.857,18.806L5.714,19.548L8.571,20.29L11.429,21.031L14.286,21.773L17.143,22.514L20,23.256L22.857,23.997L25.714,24.739L28.571,25.481L31.429,26.222L34.286,26.964L37.143,27.705L40,28.447L42.857,29.188L45.714,29.93L48.571,30.672L51.429,31.413L54.286,32.155L57.143,32.896L60,33.638L62.857,34.379L65.714,35.121L68.571,35.863L71.429,36.604L74.286,37.346L77.143,38.087L80,38.829L82.857,39.57L85.714,40.312L88.571,41.054L91.429,41.795L94.286,42.537L97.143,43.278L100,44.02L102.857,44.762L105.714,45.503L108.571,46.245L111.429,46.986L114.286,47.728L117.143,48.469L120,49.211\" class=\"ct-line\"></path></g></g><g class=\"ct-labels\"></g></svg>",
                "usagePerCustomerOvertime": {
                "daysCurrentAverageConversations": 45,
                "daysOvertimeRange": 46,
                "daysOvertimeRangeAverageConversations": 100,
                "daysPreviousAverageConversations": 0
                },
                "averageConversationsDailyData": [
                {
                    "date": "2021-02-01",
                    "averageConversations": 4,
                    "info": [
                    {
                        "numOfConversations": 1,
                        "users": 3
                    },
                    {
                        "numOfConversations": 2,
                        "users": 1
                    },
                    {
                        "numOfConversations": 3,
                        "users": 1
                    },
                    {
                        "numOfConversations": 4,
                        "users": 1
                    }
                    ]
                },
                {
                    "date": "2021-02-02",
                    "averageConversations": 2,
                    "info": [
                        {
                            "numOfConversations": 1,
                            "users": 1
                        },
                        {
                            "numOfConversations": 2,
                            "users": 1
                        },
                        {
                            "numOfConversations": 3,
                            "users": 1
                        }
                    ]
                },
                {
                    "date": "2021-02-03",
                    "averageConversations": 7,
                    "info": [
                        {
                            "numOfConversations": 1,
                            "users": 1
                        },
                        {
                            "numOfConversations": 2,
                            "users": 1
                        },
                        {
                            "numOfConversations": 8,
                            "users": 1
                        }
                    ]
                }
                ],
                "lifetimeConversationsDailyData": [
                {
                    "date": "2021-01-01",
                    "lifetimeConversations": 3,
                    "info": [
                    {
                        "numOfConversations": 1,
                        "users": 3
                    },
                    {
                        "numOfConversations": 2,
                        "users": 1
                    },
                    {
                        "numOfConversations": 3,
                        "users": 1
                    },
                    {
                        "numOfConversations": 4,
                        "users": 1
                    }
                    ]
                },
                {
                    "date": "2021-01-02",
                    "lifetimeConversations": 2,
                    "info": [
                        {
                            "numOfConversations": 1,
                            "users": 1
                        },
                        {
                            "numOfConversations": 2,
                            "users": 1
                        },
                        {
                            "numOfConversations": 3,
                            "users": 1
                        }
                    ]
                },
                {
                    "date": "2021-01-03",
                    "lifetimeConversations": 5,
                    "info": [
                        {
                            "numOfConversations": 1,
                            "users": 1
                        },
                        {
                            "numOfConversations": 2,
                            "users": 1
                        },
                        {
                            "numOfConversations": 8,
                            "users": 1
                        }
                    ]
                }
                ]
            }
            }
        }
    }
    };
    
    export default WyAnalyticsUtils;